import * as React from "react";
import { ChangeEvent } from "react";
import { connect } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import {
  Container,
  Dropdown,
  Form,
  Button,
  Modal,
  ButtonGroup,
  ToggleButtonGroup,
  ToggleButton,
  Spinner,
  Accordion,
  Card,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";
import DatePicker from "react-datepicker";
import { Utils } from "../Common/Utilis";
import { CustomerService } from "../Common/Services/CustomerService";
import { PartTemplateService } from "../Common/Services/PartTemplateService";
import { resolve, reject } from "q";
import chevronRight from "../Common/Assets/Images/icons/bx-chevron-right.svg";
import "../App.scss";
import "./slideout.scss";
import { CustomerSearch } from "../Common/Components/CustomerSearch";
import { ShippingSlideout } from './ShippingSlideout';
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { ProductService } from "../Common/Services/ProductService";
import { ConfirmationModal } from "../Common/Components/ConfirmationModal";
import { ConfirmationModalNonTable } from "../Common/Components/ConfirmationModalNonTable";
import { FiChevronDown } from "react-icons/fi";
import moment from "moment-timezone";
import { confirmAlert } from "react-confirm-alert";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import JobCreations  from './JobCreations';
import { MdBuild } from 'react-icons/md';
import { debug } from "console";
import Dropzone from "react-dropzone";
import { FaPencilAlt } from 'react-icons/fa';

import "./customer.scss";

import {
  faPlus,
  faMinus,
  faPaperclip,
  faFile,
  faFileImage,
  faFileExcel,
  faFilePdf,
  faFileCsv,
  faFileWord,
} from "@fortawesome/free-solid-svg-icons";
import { FaArrowUpFromBracket, FaCircleMinus, FaCirclePlus, FaEllipsis } from "react-icons/fa6";
import ScrollContainer from "react-indiana-drag-scroll";
import { CommentBox } from "../Common/Components/CommentBox";
import Inventory2Icon from '@mui/icons-material/Inventory2';


import PDFViewer from "./pdf-viewer";

let routeLeavingGuard: any = null;
let docViewerFiles: any = [];
let orderRequestInProcess = false;

debugger;
let storage = JSON.parse(localStorage.getItem("storage")!);
let currentUtcTime = storage === null ? "America/Chicago" : (storage.currentUtcTime as any);
const formattedDate  =   Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime);
class Customerorderslideout extends React.Component<any, any> {
  private scrollvdRef: any;
  private customerSearch: any;
  private trDate: any;
  private trdueDate: any;
  private trpoDate: any;
  private checkAllRef: any = {};
  private scrollArea: any = {};
  private parentScroll: any;
  private scrollheight: any;
  private footerchk: any;
  private ChildComment: any;
  private fileInputRef: any;

  private icheckselectedall = (column, colIndex) => {
    return (
      <div className="d-flex align-items-center txt-bold">
        <OverlayTrigger
          placement="bottom"
          overlay={
            <Tooltip id="postingRule">Click to copy below all parts</Tooltip>
          }
        >
          <FontAwesomeIcon
            icon={faArrowUp}
            size="xs"
            onClick={(e) => this.handleRowSelectionCheckAll(e, colIndex)}
          />
        </OverlayTrigger>
        {/* <input

                type="checkbox"
                onChange={(e) => this.handleRowSelectionAll(e, colIndex)}
            /> */}
      </div>
    );
  };

  private transactionsColumns = [
    {
      dataField: "id",
      text: "#",
      hidden: true,
    },
    {
      dataField: "itemNo",
      text: "#",
      hidden: true,
    },
    {
      dataField: "srno",
      text: "#",
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {

        return (
          <div>
            {rowIndex + 1}
          </div>
        );
      },
    },
    {
      dataField: "partno",
      text: "Part No.",
      headerClasses: "coa",
      style: { overflow: 'inherit' },
      headerStyle: { width: "20%" },
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),

      formatter: (cell: any, row: any, rowIndex: any) => {
        let btnId = "partno" + rowIndex + "btn";
        let id = "partno" + rowIndex + "ddl";
        const defaultPartname = row.partNo;
        // let disable =  false;
        let disable = this.state.formData.CustomerID == 0 || row.jobno != "" ? true : false;

        return (
          <div
          >
            <div className="more-action single-select-image dropdown coa-select">

              {<Typeahead

                id={"partno" + rowIndex + "ddl"}
                className="custom-typeahead"
                inputProps={{
                  className: "form-control form-control-sm partname" + rowIndex + "ddl",
                  title: defaultPartname,
                  onClick: () => this.hoverOutEllipsis()
                }}
                onInputChange={(e) => this.onInputChange(e, this, 1 + "_" + rowIndex + "_" + defaultPartname)}
                options={
                
                  this.state.productList.filter((ele, ind) => ind === this.state.productList.findIndex(elem => elem.partno === ele.partno && elem.partname === ele.partname && ele.partname !== ""))

                }
                placeholder={"Enter Part No"}
                disabled={disable}
                // disabled={row.jobno != "" || this.state.formData.CustomerID == 0 ? true : row.isdisabled == undefined ? false : row.isdisabled}
                labelKey="partno"

                renderMenu={(results: any, menuProps) => (
              
                <Menu style={{ zIndex: "-1" }} {...menuProps}>
                  <div style={{ display: 'table',  borderCollapse: 'separate', borderSpacing: '0 10px', paddingLeft :'4%' }}>
                    <div style={{ display: 'table-header-group', backgroundColor: '#f5f5f5' }}>
                      <div style={{ display: 'table-row' }}>
                        <div style={{ display: 'table-cell', fontWeight: 'bold', padding: '10px 15px', borderBottom: '1px solid #ddd' }}>
                          Part Number
                        </div>
                        <div style={{ display: 'table-cell',    fontWeight: 'bold', padding: '10px 15px', borderBottom: '1px solid #ddd' }}>
                          Part Description
                        </div>
                      </div>
                    </div>

                    <div style={{ display: 'table-row-group' }}>
                      {results.map((result: any, index: any) => (
                        result.label !== "" && result.partno !== "" && (
                          <MenuItem
                            option={result}
                            position={index}
                            style={{ display: 'table-row', backgroundColor: '#fff', marginBottom: '5px'}}
                            key={index}
                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#EBF0F4'}
                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'} 
                            onWheel={() => this.hoverOutEllipsis()}
                          >
                            <div style={{ display: 'table-cell', padding: '10px 15px', borderBottom: '1px solid #eee'}}>
                              {result.partno}
                            </div>
                            <div style={{ display: 'table-cell',  padding: '10px 15px', borderBottom: '1px solid #eee' }}>
                            
                            <div style={{width: '300px'}}>
                 <EllipsisWithTooltip placement="bottom">
                 {result.label}
                </EllipsisWithTooltip>
              </div>
                         
                            </div>
                          </MenuItem>
                        )
                      ))}
                    </div>
                  </div>
                </Menu>


                )}
            
                onChange={this.handleSelectedItem.bind(
                  this,
                  1 + "_" + rowIndex + "_" + defaultPartname
                )}
                selected={row.defaultPartname}
                //allowNew
                onBlur={this.handleOutsideClick.bind(this, rowIndex)}
                onKeyDown={this.onTAB.bind(this, "partno-" + rowIndex.toString() + "ddl", rowIndex)}

              />}

              <button id={btnId} style={{ display: "none", width: "100%" }}
                onClick={() => { this.handleCOAFocus(btnId, id, "rbt-input-main form-control rbt-input part" + rowIndex + "ddl", rowIndex); }}
                onFocus={() => { this.handleCOAFocus(btnId, id, "rbt-input-main form-control rbt-input part" + rowIndex + "ddl", rowIndex); }} >
                {row.partname === "" && (
                  <EllipsisWithTooltip placement="bottom">{"Enter Part Name"}</EllipsisWithTooltip>
                )}
                {row.partname !== "" && (
                  <EllipsisWithTooltip placement="bottom">{defaultPartname}</EllipsisWithTooltip>
                )}
              </button>
            </div>
          </div>
        );
      },
    },
    {
      dataField: "partname",
      text: "Part Description",
      headerStyle: { width: "25%" },
      hidden: false,
      editable: false,
      classes:"text-truncate",
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtpartname" + rowIndex + "txt";
        // let disable = row.jobno != "" || this.state.formData.CustomerID == 0 ? true : false;
        let disable = this.state.formData.CustomerID == 0 || row.jobno != "" ? true : false;
        return (
        
  
            <div style={{ position: 'relative' }}>
            <div className="btn-group w-100">
            
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Part Name"
              // value={row.partname}
              value={row.partname.split('\n')[0]}
              onChange={(e) => this.updateState(e, rowIndex, "partname", id)}
              onBlur={(e) => this.updateStateblur(e, rowIndex, "partname", id)}
              autoComplete="off"
              disabled={disable}
              title={row.partname}
              maxLength={500}
              className="form-control form-control-sm text-truncate"
              style={{ paddingRight: '30px',width:'100%' }} 
            />
          
             <FaPencilAlt 
            
                onClick={() => this.handleEditClick(rowIndex, row.partname, row.jobno)} 
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                }} 
              />
     
          </div>
     
          </div>
      
        );
      },

    },
    {
      dataField: "duedate",
      text: "Due Date",
      headerStyle: { width: "10%" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtduedate" + rowIndex + "txt";
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
          <div className="date-picker calender-picker" onClick={(e) => this.onclickevent(e)}>
            <DatePicker
              ref={this.trdueDate}
              id={id}
              tabIndex={this.state.tabEnable}
              className="form-control form-control-sm"
              placeholderText={"MM/DD/YY"}
              dateFormat="MM/dd/yy"
              onChangeRaw={this.handleRawChange}
              selected={
                row.dueDate === null
                  ? new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime))
                  : row.dueDate === ""
                    ?  new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime))
                    : new Date(row.dueDate)
              }
              onChange={(e) => this.updateState(e, rowIndex, "dueDate", id)}

              onKeyDown={(e: any) =>
                this.onTAB.bind(
                  this,
                  "txtduedate-" + rowIndex.toString() + "txt",
                  rowIndex
                )
              }
              autoComplete="off"
              //onKeyDown={this.onTAB.bind(this, "txttotal-" + rowIndex.toString() + "txt", rowIndex)}
              // disabled={isBedgeProcessing && true}
              disabled={disable}
            />
          </div>
        );
      },
    },

  
    {
      dataField: "",
      text: "Unit",
      headerStyle: { width: "5%" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtunit" + rowIndex + "txt";
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder=""
              value={row.unit}
              onChange={(e) => this.updateState(e, rowIndex, "unit", id)}
              autoComplete="off"
              disabled={disable}
              title=""
              maxLength={50}
              className="form-control form-control-sm"
            />
          </div>
        );
      },
    },
    {
      dataField: "",
      text: "Qty",
      headerStyle: { width: "10%" },
      hidden: false,
      editable: false,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtqty" + rowIndex + "txt";
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Qty"
              value={row.qtyOrdered}
              onChange={(e) => this.updateState(e, rowIndex, "qtyOrdered", id)}
              //  onBlur={(e: any) => this.amountBlur(e, rowIndex, "qtyOrdered")}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={disable}
              title=""
              className="form-control form-control-sm"
            />
          </div>
        );
      },
    },

    {
      dataField: "unitprice",
      text: "Unit Price",
      headerStyle: { width: "10%" },
      hidden: false,
      editable: false,
      headerClasses: 'amount',
      classes: 'amount',
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtunitprice" + rowIndex + "txt";
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Unit Price"
              value={row.unitPrice}
              onChange={(e) => this.updateState(e, rowIndex, "unitPrice", id)}
              onBlur={(e: any) => this.amountBlur(e, rowIndex, "unitPrice")}
              onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "unitPrice")}
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              autoComplete="off"
              disabled={disable}
              title=""
            //  className="form-control form-control-sm"
            />
          </div>
        );
      },
    },


    {
      dataField: "qty",
      text: "Discount",
      headerStyle: { width: "10%" },
      hidden: false,
      editable: false,
      headerClasses: 'amount',
      classes: 'amount',
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtdiscount" + rowIndex + "txt";
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder="Enter Discount"
              value={row.discount}
              onChange={(e) => this.updateState(e, rowIndex, "discount", id)}
              onBlur={(e: any) => this.amountBlur(e, rowIndex, "discount")}
              onFocus={(e: any) => this.onAmountFocus(e, rowIndex, id, "discount")}
              autoComplete="off"
              pattern="[+-]?\d+(?:[.,]\d+)?"
              maxLength={20}
              disabled={disable}
              title=""
              className="form-control form-control-sm"
            />
          </div>
        );
      },
    },

    {
      dataField: "total",
      text: "Total",
      headerStyle: { width: "20%" },
      hidden: false,
      editable: false,
      headerClasses: 'amount',
      classes: 'amount',
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txttotal" + rowIndex + "txt";
        let disable = this.state.formData.CustomerID == 0 ? true : false;
        return (
          <div>
            <Form.Control
              tabIndex={this.state.tabEnable}
              id={id}
              type="text"
              placeholder=""
              value={Utils.currencyFormat(Utils.removecurrencyFormat(row.qtyOrdered) * Utils.removecurrencyFormat(row.unitPrice) - Utils.removecurrencyFormat(row.discount))}
              // onChange={(e) => this.updateState(e, rowIndex, "amount", id)}
              pattern="[+-]?\d+(?:[.,]\d+)?"
              //  onBlur={(e: any) => this.amountBlur(e, rowIndex,"amount")}
              onKeyDown={(e: any) => this.handleBlur(e, rowIndex)}
              maxLength={20}
              autoComplete="off"
              disabled={disable}
              title=""
              className="form-control form-control-sm"
            // onKeyDown={this.onTAB.bind(this, "txttotal-" + rowIndex.toString() + "txt", rowIndex)}
            />
          </div>
        );
      },
    },
    {
      dataField: "Attachment",
      text: "",
      //headerFormatter: this.iconFormatter,
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let confirmModalContent = [
          {
            title: "Delete Row",
            desc: "Are you sure you want to delete?",
            cancleAction: "Cancel",
            ActionTrue: "Delete",
          },
        ];
        if (this.state.orderData.length === 1 || rowIndex == 0 || row.jobno != "") {


          return (
            <div></div>
          );

        }

        else {
          return (
            <Dropdown
              className="more-action confirmation-modal"
              
              tabIndex={this.state.tabDisable}
            >
              <Dropdown.Toggle
                className="btn-outline-primary btn btn-primary more fa-trash"
                id="dropdown-more-delete"
                tabIndex={this.state.tabDisable}
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M5 5.83329C4.53917 5.83329 4.16667 5.83329 4.16667 5.83329V16.6666C4.16667 17.5866 4.91333 18.3333 5.83333 18.3333H14.1667C15.0867 18.3333 15.8333 17.5866 15.8333 16.6666V5.83329C15.8333 5.83329 15.4608 5.83329 15 5.83329H5ZM8.33333 15.8333H6.66667V8.33329H8.33333V15.8333ZM13.3333 15.8333H11.6667V8.33329H13.3333V15.8333ZM13.8483 3.33329L12.5 1.66663H7.5L6.15167 3.33329H2.5V4.99996H6.66667H13.3333H17.5V3.33329H13.8483Z" />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <ConfirmationModal
                  confirmModalContent={confirmModalContent}
                  ishandleDeletePosition={this.ishandleDeleteRow.bind(
                    this,
                    row
                  )}
                />
              </Dropdown.Menu>
            </Dropdown>
          );
        }
      },
    },

    {
      dataField: "",
      text: "Job Order",
      headerStyle: { width: "200px" },
      hidden: false,
      editable: false,

      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          if (row.id == 0) {
            this.setState({ unsave: true });
            // alert('Please save this record before creating its job.');     
            //this.saveOrderfinal("order", false,false);
          }
          else {

            let rNo = '';
            if (row.jobno != "") {
              row.itemNo = Utils.extractNumberAfterHyphen(row.jobno);
              rNo = Utils.extractRNumber(row.jobno);
            }
            else {
              const maxNumberAfterHyphen = this.state.orderData.reduce((max, { jobno }) => {
                const numberAfterHyphen = Utils.extractNumberAfterHyphen(jobno);
                return Math.max(max, numberAfterHyphen);
              }, -Infinity);
              row.itemNo = maxNumberAfterHyphen === -Infinity ? 1 : maxNumberAfterHyphen + 1;
            }
            this.ShowJobModal(row.itemNo, row.productid, row.partname, row.partNo, row.qtyOrdered, this.state.poNumber, row.dueDate, row.jobDesc, row.id, row.jobid, rNo);
          }

        },
      },
      headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
      formatter: (cell: any, row: any, rowIndex: any) => {
        let id = "txtjobid" + rowIndex + "txt";
        let disable = false;
        if (this.state.orderid == 0) {
          return <div></div>;
        }

        else {
          if (row.jobno != "") {
            return (

              <Button className="btn-link">
                {row.jobno}
              </Button>
            );
          }
          else {
            return (

              <div className='text-gray-400 btn-link"'>
                <Button className="btn-link">
                  <MdBuild title="Click to create job" />
                </Button>
              </div>
            );
          }
        }
      },
    }


  ];

  constructor(props: any) {
    super(props);
    this.parentScroll = React.createRef();
    this.scrollvdRef = React.createRef();
    this.customerSearch = React.createRef();
    this.trDate = React.createRef();
    this.trpoDate = React.createRef();
    this.trdueDate = React.createRef();
    this.onDrop = this.onDrop.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.handleSaveFiles = this.handleSaveFiles.bind(this);
    this.isHandleAction = this.isHandleAction.bind(this);
    this.handleCustomerChange = this.handleCustomerChange.bind(this);
    this.Previoustransactions = this.Previoustransactions.bind(this);
    this.handlePreview = this.handlePreview.bind(this);
    this.scrollheight = React.createRef();
    this.GetUploadFileList = this.GetUploadFileList.bind(this);
    this.getprocesslist = this.getprocesslist.bind(this);
    this.handleUpdatedFile = this.handleUpdatedFile.bind(this);
    this.OpenViewer = this.OpenViewer.bind(this);
    this.ShowJobModal = this.ShowJobModal.bind(this);
    this.loadPreviousData = this.loadPreviousData.bind(this);
    this.ChildComment = React.createRef();
    this.fileInputRef = React.createRef();
    
    this.state = {
      editingIndex: null,
      currentNote: '',
      showPopup: false,

      requestlistprev: { recordCount: 5000, customerid: 0, tenantid: 0 },
      displayRecordCount: 5,
      searchPreviousData: '',
      fileSelect:
        "data:application/pdf;base64,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",

      prevOrderidselected: 0,
      isTab: 0,
      isBack: 0,
      IsDeleted: true,
      CustomerPoNumber: "",
      itemNo: 0,
      partname: "",
      partNo: "",
      orderType: '',
      qtyOrdered: 0,
      poNumber: 0,
      dueDate: ""
      , jobDesc: "",
      id: 0,
      rNo: '',
      productid: 0,
      Isadded: true,
      rowData: 0,
      defaultView: "doc-view",
      tabEnable: 0,
      orderid: this.props.orderid,
      address: this.props.address,
      customercode: this.props.customercode,
      customerNameLatest: this.props.selectedCustomer,
      selectedCustomer: this.props.selectedCustomer,
      productList: [],
      Defaultselected: [],
      options: [],
      selectedChk: [],
      orderResult: [],
      previousOrderData: [],
      orderResultDetails: [],
      bulkSelect: false,
      isprevious: false,
      files: [],
      files1: [],
      savedfiles: [],
      newSelectfiles: [],
      orderlistitem: [],
      transactionsColumns: this.transactionsColumns,
      totalCount: 0,
      bulkSelectedOrderRows: [],
      isOpenViewer: false,
      currentZoom: 0.7,
      //timeZone:timeZone,
      chkIds: [],
      // responsive :"table-responsive",
      moreActionFileUpload1: [
        { name: "Delete", eventKey: "delete" },
        { name: "Download", eventKey: "download" },
        { name: "View", eventKey: "view" },
      ],
      orderData: [
        {
          srno: 1,
          defaultPartname: [],
          id: 0,
          orderID: 0,
          itemNo: 1,
          partname: "",
          partNo: "",
          dueDate: formattedDate,
          jobDesc: "",
          qtyOrdered: 1,
          unit: "EA",
          unitPrice: Utils.currencyFormat(0),
          discount: Utils.currencyFormat(0),
          total: Utils.currencyFormat(0),
          tenantid: 0,
          productid: 0,
          jobno: "",
          jobid: 0,
          isdisabled: false,
        },
        // {
        //   srno:2,
        //   defaultPartname: [],
        //   id: 0,
        //   orderID: 0,
        //   itemNo: 2,
        //   partname: "",
        //   partNo: "",
        //   dueDate: "",
        //   jobDesc: "",
        //   qtyOrdered: 0,
        //   unit: "",
        //   unitPrice: 0,
        //   discount: 0,
        //   total: 0,
        //   tenantid: 0,
        //   productid: 0,
        //   jobno: "",
        //   jobid: 0,
        // },
        // // ,
        // {
        //     // defaultPartname: [],
        //     id: 0, orderID: 0, itemNo: 2, partname: '', partNo: '', dueDate: '', jobDesc: '', qtyOrdered: 0, unit: '', unitPrice: 0, discount: 0, total: 0, tenantid: 0, productid: 0,
        // }
      ],
      defaultorderData: [],
      processdataList: [],
      newRow:
      {
        srno: 1,
        defaultPartname: [],
        id: 0,
        orderID: 0,
        itemNo: 1,
        partname: "",
        partNo: "",
        dueDate:  formattedDate,
        jobDesc: "",
        qtyOrdered: 1,
        unit: "EA",
        unitPrice: 0,
        discount: 0,
        total: 0,
        tenantid: 0,
        productid: 0,
        jobno: "",
        jobid: 0,
        isdisabled: false,
      },
      formData: {
        shipmentNumbers:'N/A',
        OrderID: 0,
        CustomerID: 0,
        CustomerName: "",
        CustomerPoNumber: "",
        shippingInstruction: "",
        OrderDate: this.props.orderid > 0 ? null :formattedDate,
        BuyerName: "",
        quotationNo: "",
        ExternalCustomerPO: "",
        QuotationNo:"",
        ExternalOrderDate: formattedDate,
        Address: "",
        customercode: "",
        IsEdit: "",
        OrderItems: [],
      },
      fileSize: 5242880,
    };
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.updatedCommentItem = this.updatedCommentItem.bind(this);
  }

  handleEditClick = (rowIndex, currentDesc,jobno) => {
   
    this.setState({
      editingIndex: rowIndex,
      currentNote: currentDesc,
      showPopup: true,
      selectedjobno:jobno,
    });
  };

  handleNotesSave = () => {

    let orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    const { editingIndex, currentNote } = this.state;
    orderData[editingIndex].partname = currentNote;
    this.setState({ showPopup: false, editingIndex: null, currentNote: '' ,orderData, isStateChanged: true});
  };


  handleUpdatedFile() {
    return this.state.chkIds;
  }
  handleFileCheckBox = (event, files, fileNo, selectedId, chktype) => {
    this.setState({ isExtractOption: false });
    if (chktype === "bulkSelect") {
      if (!event.target.checked) {
        this.setState({ chkIds: [], selectedChk: [] });
      } else {
        const newIds = [...this.state.chkIds];
        files.forEach((element) => {
          for (let inx = 0; inx < element.totalpage; inx++) {
            let id = element.fileNo.toString() + "_" + inx.toString();
            const selectedId1 = `custom_${id}`;
            const newId = this.state.chkIds.filter((x) => x.id === selectedId1);
            if (newId.length === 0) {
              let item: any = {};
              item.id = selectedId1;
              item.fileNo = element.fileNo;
              newIds.push(item);
            }
          }
          this.setState({ chkIds: newIds });
        });
      }
    } else if (chktype === "All") {
      if (!event.target.checked) {
        const newIds = this.state.chkIds.filter((x) => x.fileNo !== fileNo);
        this.setState({ chkIds: newIds });
        // setchkIds(newIds);
      } else {
        const newIds = [...this.state.chkIds];
        files
          .filter((x) => x.fileNo === fileNo)
          .forEach((element) => {
            for (let inx = 0; inx < element.totalpage; inx++) {
              let id = element.fileNo.toString() + "_" + inx.toString();
              const selectedId1 = `custom_${id}`;
              const newId = this.state.chkIds.filter(
                (x) => x.id === selectedId1
              );
              if (newId.length === 0) {
                let item: any = {};
                item.id = selectedId1;
                item.fileNo = element.fileNo;
                newIds.push(item);
              }
            }
            this.setState({ chkIds: newIds });
            // setchkIds(newIds);
          });
      }
    } else {
      // const selectedId = `custom_${id}`

      if (!event.target.checked) {
        const newIds = this.state.chkIds.filter((x) => x.id !== selectedId);
        this.setState({ chkIds: newIds });
      } else {
        const newIds = [...this.state.chkIds];
        let item: any = {};
        item.id = selectedId;
        item.fileNo = fileNo;
        newIds.push(item);
        this.setState({ chkIds: newIds });
      }
    }
  };
  handlePreview = (file: any) => {
    this.setState({ fileSelect: "", isOpenViewer: false }, () => {
      this.setState(
        { fileSelect: file, isOpenViewer: false, fileName: file.name },
        () => {
          if (this.state.isOpenViewer) {
            setTimeout(() => {
              const innerWidthSec = this.scrollheight.current
                .getElement()
                .getBoundingClientRect().height;
              this.setState({ scrollAreaHeight: innerWidthSec });
            }, 100);
          }
        }
      );
    });
  };
  scrollToBottom = () => {

    /* this.parentScroll.current.scrollTo({
       //top: this.parentScroll.current.clientHeight,
       top: this.parentScroll.current.scrollHeight,
       behavior: "smooth",
     }); */
  };
  ishandleDeleteRow(row: any, mode: any) {
    if (mode) {
      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );
      let isStateChanged = true;
      this.setState({ orderData: [] }, () => {
        const orderDataNewc = orderData
          .filter((item) => (row.id === 0 && item.itemNo !== row.itemNo) || item.id !== row.id)
          .map((item, index) => {
            item.itemNo = index + 1;
            return item;
          });

        this.setState(
          {
            orderData: orderDataNewc, isStateChanged: isStateChanged

          }
        );
      });
    }
  }
  updatedCommentItem = () => {

    let updatedItem: any = {};
    this.setState({ isSave: true });
    updatedItem.transcationDate = this.state.formData.transcationDate;
    updatedItem.vendorName = this.state.formData.vendorName;
    updatedItem.amountTotal = this.state.totalAmount;
    return updatedItem;
  };
  CommentModalClose = () => {

    let uniqueno = this.state.formData.uniqueno;
    this.handleDiscard(uniqueno);
  };

  closeSlideOut = () => {
    this.props.closeSlideOut(this.state?.shouldReloadMainPage);
    this.setState({ isOpenViewer: false });
  };

  closeSlideOut2 = () => {

    this.setState({ showjobrModal: false, isSpinner: false, isOpenViewer: false });

    this.GetorderEntryColoumn();
  };

  reopenSlideOutWithNextJob = () => {
    this.setState({ showjobrModal: false, isSpinner: false, }, () => {
      this.GetorderEntryColoumn(true);
    });


  };


  reopenSlideOutWithReworkJob = () => {

    this.setState({ showjobrModal: false, isSpinner: false, }, () => {
      debugger;
      this.GetorderEntryColoumn(true, true);
    });


  };



  handleNewRow = () => {
    let orderData: any = [];
    let newRow: any = {};
    let isStateChanged = true;

    orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );
    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.newRow)));

    let maxValueOfRow = Math.max(...orderData.map((o) => o.itemNo), 0);
    let len = orderData.length;
    let maxRno = maxValueOfRow;
    let maxSrno = orderData[len - 1].srno;

    // if(orderData[len - 1].partNo!="")
    // {

    newRow.itemNo = Number(maxRno) + 1;
    newRow.srno = Number(maxSrno) + 1;
    newRow.dueDate = formattedDate;
    // newRow.dueDate = orderData[len - 1].dueDate;
    // newRow.qtyOrdered = orderData[len - 1].qtyOrdered;
    orderData.push(newRow);

    this.setState({ orderData: [] }, () => {
      this.setState({ orderData: orderData, isStateChanged }, () => {
        let len = orderData.length;
        let txtID = "txtpartno" + (len - 1) + "txt";
        // setTimeout(() => {
        //   //  this.trDate.current.setOpen(true);
        //   $("input[id^='" + txtID + "']").focus();
        //   //       $("#tblOrder")
        //   // .find("input[class^='" + txtID + "']")
        //   // .focus();
        // }, 50);

      });
    });
    // }
    // else
    // {

    //   let len = orderData.length;
    //   let txtID = "txtpartno" + (len - 1) + "txt";
    //   setTimeout(() => {
    //     //  this.trDate.current.setOpen(true);
    //     $("input[id^='" + txtID + "']").focus();
    //     //       $("#tblOrder")
    //     // .find("input[class^='" + txtID + "']")
    //     // .focus();
    //   }, 50);
    //   reject();

    // }
    // this.setState({  orderData: orderData, isStateChanged }, () => {
    //   setTimeout(() => {
    //     let txtID =
    //       "txtpartno" +
    //       Number(maxRno) +
    //       "txt";
    //     $("#tblOrder")
    //       .find("input[class^='" + txtID + "']")
    //       .focus();
    //   }, 50);
    // });

    //$("#tblOrder").find("input[class^='" + txtID + "']").focus();
  };

  beforeunload(e: { preventDefault: () => void; returnValue: boolean }) {
    if (
      this.state.isStateChanged &&
      routeLeavingGuard !== "routeLeavingGuardTrue"
    ) {
      e.preventDefault();
      e.returnValue = true;
    }
  }

  routeLeavingGuardConfirm = (childState: any) => {
    if (childState === true) {
      routeLeavingGuard = "routeLeavingGuardTrue";
    } else {
      routeLeavingGuard = null;
    }
  };

  componentDidMount() {
    this.getprocesslist();
    this.onLoadData();
    let requestlist = { ...this.state.requestlist };
     this.GetorderEntryColoumn();
    // this.GetProductlist(requestlist);

  }

  componentDidUpdate(prevProps) {
    if (prevProps.locationId != this.props.locationId) {
      this.closeSlideOut();
    }
  }

  getprocesslist = () => {
    let processdataList: any = [];
    let requestlist = { ...this.state.requestlist };


    PartTemplateService.GetProcessList(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {

          result.forEach(element => {

            let item: any = {};
            item.srno = element.srno;
            item.id = element.id;
            item.name = element.processName;
            item.description = element.pDescription;
            item.isFixed = element.isFixed;
            processdataList.push(item);
            //Typelistprocess.push(item);
          });
          this.setState({
            processdataList: processdataList,

          });




        }
        resolve();
      });
    // .catch((error) => {

    //   reject();
    // });


  };


  GetProductlist = (requestlist: any) => {
    requestlist.customerid = this.state.formData.CustomerID;
    this.setState({ isSpinner: false });
    let orderData: any = [];
    let newRow: any = {};
    orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );
    newRow = Object.assign({}, JSON.parse(JSON.stringify(this.state.newRow)));

    ProductService.GetProductOrderlist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ orderData: [] }, () => {
            this.setState(
              {
                orderData: orderData,
                newRow: newRow,
                productList: result,
                isSpinner: this.state.orderid === 0 ? false : false,
              },
              () => {
                let formData = { ...this.state.formData };

                // this.GetorderEntryColoumn();
              }
            );
          });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSpinner: false });
        reject();
      });
  };

  GetorderEntryColoumn = (openNextJob: any = false, reworkJob: any = false) => {
    let saveRequest: any = {};
    saveRequest.orderid = this.state.orderid;
    saveRequest.tenantid = 0;
    let joblist: any = [];
    // CustomerService.GetCustomerlistjob(saveRequest)
    //   .then(async (resultjob: any | null) => {
    //     if (resultjob !== null) {
    //       resultjob.forEach(element => {
    //         let item: any = {};
    //         item.id = element.id;
    //         item.jobid = element.jobid;
    //         item.jobno = element.jobno;
    //         item.partid = element.partid;

    //         joblist.push(item);
    //       });






    //     }
    //     resolve();
    //   })
    //   .catch((error) => {

    //     reject();//
    // });

    let requestlist = { ...this.state.requestlist };
    //this.GetProductlist(requestlist);
    let productList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.productList))
    );
    let orderData: any = [];
    CustomerService.Getorderdataoptimize(saveRequest)
      .then(async (result: any | null) => {
        if (result !== null) {
          if (result.customerOrderToUpdateList[0] !== undefined) {


            let options: any = [];

            result.customerContact.forEach(element => {

              let item: any = {};
              item.id = element.id;
              item.name = element.firstname;
              options.push(item);

            });

            let custommerSelected: any = [];
            let IsDeleted: any = true;
            let orderArray: any = [];
            let mainArray = result.customerOrderToUpdateList[0];
            orderArray = result.customerOrderDetailsToUpdateList;


            let uploadFiles = result.uploadFileList;


            for (let i = 0; i < uploadFiles.length; i++) {
              this["myRef" + i] = React.createRef();
            }


            let formData = { ...this.state.formData };
            formData.OrderID = mainArray.orderID;
            formData.CustomerID = mainArray.customerID;
            formData.CustomerName = mainArray.customerName;
            formData.quotationNo = mainArray.quotationNo;
            formData.customercode = mainArray.customercode;
            formData.CustomerPoNumber = mainArray.customerPoNumber;
            formData.shippingInstruction = mainArray.shippingInstructions;
            formData.ExternalCustomerPO = mainArray.externalCustomerPO;
            formData.QuotationNo=mainArray.quotationNo;
            formData.BuyerName = mainArray.buyerName == null ? "" : mainArray.buyerName;
formData.shipmentNumbers=mainArray.shipmentNumbers;

            let Defaultselected: any = [];
            let objData: any = {};

            objData.id = mainArray.buyerName;
            objData.name = mainArray.buyerName == null ? "" : mainArray.buyerName;
            Defaultselected.push(objData);

            formData.ExternalOrderDate = mainArray.externalOrderDate;

            formData.OrderDate = mainArray.orderDate;
            formData.Address = mainArray.address;
            custommerSelected.company_name = mainArray.customerName;
            custommerSelected.address = mainArray.address;
            custommerSelected.customer_id = mainArray.customerID;
            custommerSelected.customercode = mainArray.customercode;
            this.customerSearch?.current.handleSelectFromParent(
              custommerSelected
            );
            let orderlist: any = [];
            if (orderArray.length > 0) {
              orderArray.forEach((element) => {

                let defaultPartname: any = [];
                let objPartname: any = {};

                objPartname.partname = element.partname;
                objPartname.label = element.partname;
                objPartname.id = element.productid;
                objPartname.partno = element.partNo;
                objPartname.tenantid = 0;
                objPartname.unit = element.unit;
                objPartname.unitPrice = Utils.currencyFormat(element.unitPrice);
                objPartname.noofday = null;
                objPartname.jobDesc =  element.partname;
                //element.jobDesc;

                defaultPartname.push(objPartname);
                element.defaultPartname = defaultPartname;




                element.unitPrice = Utils.currencyFormat(element.unitPrice);
                element.discount = Utils.currencyFormat(element.discount);

                orderData.push(element);

                let orderlistItem: any = [];

                //   dueDate:'',jobDesc:'',qtyOrdered:'',unit:'',unitPrice:'',discount:'',total:''
                orderlistItem.itemNo = element.itemNo;
                orderlistItem.partname = element.partname;
                orderlistItem.partno = element.partNo;
                orderlistItem.dueDate = element.dueDate;
                orderlistItem.jobDesc = element.partname;
                // element.jobDesc;
                orderlistItem.qtyOrdered = element.qtyOrdered;
                orderlistItem.unit = element.unit;
                orderlistItem.unitPrice = Utils.currencyFormat(element.unitPrice);
                orderlistItem.discount = Utils.currencyFormat(element.discount);
                orderlistItem.total = element.total;
                orderlistItem.productid = element.productid;


                orderlistItem.jobno = element.jobno;
                orderlistItem.jobid = element.jobid;
                if (IsDeleted == true) {
                  if (orderlistItem.jobid != null) {
                    if (orderlistItem.jobid != 0) {
                      IsDeleted = false;

                    }
                  }
                }
                orderlist.push(orderlistItem);
              });
            } else {
              orderData = Object.assign(
                [],
                JSON.parse(JSON.stringify(this.state.orderData))
              );
            }


            this.setState({ orderData: [] }, () => {
              this.setState(
                {
                  IsDeleted: IsDeleted,
                  options: options,
                  Defaultselected: Defaultselected,
                  orderData: orderData,
                  productList,
                  formData: formData,
                  poNumber: mainArray.poNumber,
                  productid: 0,
                  isSpinner: false,
                  defaultView: "doc-view",
                },
                () => {

                  if (openNextJob) {
                    const index = orderData.findIndex(item => item.id === this.state.id);
                    let row = orderData.filter((item, i) => i > index);
                    if (reworkJob) {
                      row = orderData.filter((item, i) => i == index);
                      row[0].jobid = 0;
                    }
                    // let row = this.state.orderData.filter((x)=> x.jobid ===0 && x.id !== this.state.id);

                    if (row != null && row.length > 0) {
                      let jobNo = Utils.removeRNumber(row[0].jobno);
                      let rNo = '';
                      if (row[0].jobno != "") {
                        row[0].itemNo = Utils.extractNumberAfterHyphen(jobNo);
                        if (reworkJob)
                          rNo = Utils.extractIncrementedRNumber(row[0].jobno);
                      }
                      else {
                        const maxNumberAfterHyphen = this.state.orderData.reduce((max, { jobno }) => {
                          const numberAfterHyphen = Utils.extractNumberAfterHyphen(Utils.removeRNumber(jobno));
                          return Math.max(max, numberAfterHyphen);
                        }, -Infinity);
                        row[0].itemNo = maxNumberAfterHyphen === -Infinity ? 1 : maxNumberAfterHyphen + 1;
                      }

                      let lastItem = this.state.orderData.length > 0 ? this.state.orderData[this.state.orderData.length - 1] : null;
                      let lastItemId = lastItem != null ? lastItem.id : 0;
                      if (lastItemId != this.state.id || reworkJob)
                        this.ShowJobModal(row[0].itemNo, row[0].productid, row[0].partname, row[0].partNo, row[0].qtyOrdered, row[0].poNumber, row[0].dueDate, row[0].jobDesc, row[0].id, row[0].jobid, rNo);
                    }
                  }
                  this.GetUploadFileList(this.state.orderid, 1);
                  this.Previoustransactions();
                  this.GetProductlist(requestlist);
                  if (this.state.savedfiles.length != 0) {
                    // this.OpenViewer();
                  }
                }
              );

            });

          }
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSaveSpinner: false });
        reject();
      });
  };

  handleButtonClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  onclickevent = (e) => {
    //  $("#order").removeClass("table-responsive");
    // this.setState({responsive : "table-responsiveremove"});
  };

  handleRawChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value != undefined) {
      const maxLength = 8; // Set the maximum length you want
      if (e.target.value.length > maxLength) {
        e.preventDefault();
        e.target.value = e.target.value.slice(0, maxLength);
      }
    }
  };

  updateState = (e: any, index: any, type: any, txtID) => {
    if (this != undefined && e != null) {

      let isStateChanged = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );

      if (type === "discount") {

        e.preventDefault();
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        orderData[index].discount = e.target.value;




        this.setState({ orderData, isStateChanged }, () => {


          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
        // 
        // e.preventDefault();
        // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        // e.target.value = newVal;
        // orderData[index].discount = e.target.value;

        // this.setState({ orderData, isStateChanged }, () => {
        //   $("#tblOrder")
        //     .find("input[id^='" + txtID + "']")
        //     .focus();
        //   let txtdesc = $("#tblOrder").find(
        //     "input[id^='" + txtID + "']"
        //   )[0] as any;
        //   if (txtdesc !== null && txtdesc !== undefined) {
        //     txtdesc.selectionStart = start;
        //     txtdesc.selectionEnd = end;
        //   }
        // });

      }



      if (type === "partNo") {
        e.preventDefault();



        orderData[index].partNo = e.target.value;


        this.setState({ orderData, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }


      if (type === "dueDate") {
        //  e.preventDefault();

        //  orderData[index].dueDate = e.target.value;


        let today = new Date(e);
        let dateNew =
          today.getMonth() +
          1 +
          "/" +
          today.getDate() +
          "/" +
          today.getFullYear().toString().substring(2, 4);
        let todaynew = new Date(dateNew);
        let dateNewt =
          todaynew.getMonth() +
          1 +
          "/" +
          todaynew.getDate() +
          "/" +
          todaynew.getFullYear().toString().substring(0, 4);
        //formData.OrderDate = dateNewt;       
        
        
        orderData[index].dueDate =dateNewt;
        
      //  orderData[index].dueDate = e.toISOString();
        //let  responsive ="table-responsiveadd";
        //  this.setState({ formData, isStateChanged });
        //$("#order").addClass("table-responsive");
        this.setState({ orderData, isStateChanged }, () => {
          let id = "txtdescription" + index + "txt";
          //$("#tblOrder").find("input[id^='" + id + "']").focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + id + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      if (type === "jobDesc") {
        e.preventDefault();

        orderData[index].jobDesc = e.target.value;

        this.setState({ orderData, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }
      if (type === "partname") {
        e.preventDefault();



        orderData[index].partname = e.target.value;


        this.setState({ orderData, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      if (type === "qtyOrdered") {
        e.preventDefault();
        let newVal = e.target.value.replace(/[^0-9\s]/g, '');
        e.target.value = newVal;
        ///const rx_live = /^[-]?\d*(?:[.]\d*)?$/;
        orderData[index].qtyOrdered = e.target.value;

        this.setState({ orderData, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }

      if (type === "unit") {
        e.preventDefault();
        // let newVal = Utils.removeInvaildCharFromAmount(e.target.value);

        orderData[index].unit = e.target.value;
        this.setState({ orderData, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });

        // this.setState({ orderData, isStateChanged }, () => {
        //   $("#tblOrder")
        //     .find("input[id^='" + txtID + "']")
        //     .focus();
        //   let txtdesc = $("#tblOrder").find(
        //     "input[id^='" + txtID + "']"
        //   )[0] as any;
        //   if (txtdesc !== null && txtdesc !== undefined) {
        //     txtdesc.selectionStart = start;
        //     txtdesc.selectionEnd = end;
        //   }
        // });
      }

      if (type === "unitPrice") {
        e.preventDefault();
        let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
        e.target.value = newVal;
        orderData[index].unitPrice = e.target.value;

        this.setState({ orderData, isStateChanged }, () => {
          $("#tblOrder")
            .find("input[id^='" + txtID + "']")
            .focus();
          let txtdesc = $("#tblOrder").find(
            "input[id^='" + txtID + "']"
          )[0] as any;
          if (txtdesc !== null && txtdesc !== undefined) {
            txtdesc.selectionStart = start;
            txtdesc.selectionEnd = end;
          }
        });
      }


    }
  };

  onLoadData() {
    this.setState({ isjobcreate: false });
    let pros = this.props;
    let requestlist = { ...this.state.requestlist };
    if (this.customerSearch.current !== null) {
      this.customerSearch.current.GetCustomerTranlist(requestlist);
    }
  }

  updateCustomerList = (result: any) => {
    this.setState({ customerList: [] }, () => {
      this.setState({ customerList: result });
    });
  };

  handleChange = (event: any, FieldType: string) => {

    let isStateChanged = true;
    let start = 0;
    let end = 0;

    let formData = { ...this.state.formData };

    if (FieldType === "CustomerName") {
      formData.CustomerName =
        event.target.value.trim().length > 0 ? event.target.value : "";
    } else if (FieldType === "CustomerPoNumber") {
      formData.CustomerPoNumber =
        event.target.value.trim().length > 0 ? event.target.value : "";
    } else if (FieldType === "shippingInstructions") {
      formData.shippingInstruction =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }
    else if (FieldType === "ExternalCustomerPO") {
      formData.ExternalCustomerPO =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }
    else if(FieldType==="QuotationNo")
    {

      formData.QuotationNo =
      event.target.value.trim().length > 0 ? event.target.value : "";
    }
    else if (FieldType === "BuyerName") {
      formData.BuyerName =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }else if (FieldType === "quotationNo") {
      formData.quotationNo =
        event.target.value.trim().length > 0 ? event.target.value : "";
    }
    else if (FieldType === "ExternalOrderDate") {
      // formData.ExternalOrderDate = event.toISOString();
      // this.setState({ formData, isStateChanged });

      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear().toString().substring(2, 4);
      let todaynew = new Date(dateNew);
      let dateNewt =
        todaynew.getMonth() +
        1 +
        "/" +
        todaynew.getDate() +
        "/" +
        todaynew.getFullYear().toString().substring(0, 4);
      formData.ExternalOrderDate = dateNewt;
      // this.setState({ formData, isStateChanged });
    }

    else if (FieldType === "orderDate") {
      //   formData.OrderDate = event.target.value.trim().length > 0 ? event.target.value : "";
      let today = new Date(event);
      let dateNew =
        today.getMonth() +
        1 +
        "/" +
        today.getDate() +
        "/" +
        today.getFullYear().toString().substring(2, 4);
      let todaynew = new Date(dateNew);
      let dateNewt =
        todaynew.getMonth() +
        1 +
        "/" +
        todaynew.getDate() +
        "/" +
        todaynew.getFullYear().toString().substring(0, 4);
      formData.OrderDate = dateNewt;
      //   this.setState({ formData, isStateChanged });
    } else if (FieldType === "address") {
      formData.address = event.target.value.replace("'", "");
    } else if (FieldType === "check") {
      if (event.target.value.length > 0) {
        if (Number(event.target.value)) {
          formData.checkNo = Number(event.target.value);
        }
      } else {
        formData.checkNo = event.target.value;
      }
    } else if (FieldType === "repeat") {
      formData.isRepeat = event.target.checked ? "Yes" : "No";
      this.setState({ isRepeat: event.target.checked });
    }
    else if (FieldType === "SearchPreviousData") {
      this.setState({ searchPreviousData: event.target.value });
    }

    this.setState({ formData, isStateChanged, isSpinner: false }, () => {
      if (FieldType === "invoiceno") {
        let txtID = "txtInvoice";
        let txtInvoice = $("input[id^='" + txtID + "']")[0] as any;
        txtInvoice.selectionStart = start;
        txtInvoice.selectionEnd = end;
      }
    });
  };

  handleDatePicker = (event: any, refName: any) => {
    refName.current.setOpen(true);
  };

  handleCustomerChange = (e: any) => {
    let isStateChanged = true;
    if (e.length > 0) {
      let requestlist = { ...this.state.requestlist };

      let formData = { ...this.state.formData };
      requestlist.vid = e[0].customer_id;
      formData.CustomerID = e[0].customer_id;
      formData.CustomerName = e[0].company_name;
      formData.address = e[0].address;
      formData.customercode = e[0].customercode;

      //      this.state.formData.BuyerName= e[0].firstname;
      let options: any = [];
      let Defaultselected: any = [];
      
    
      if(e[0].customerContact==undefined)
      {
        let item: any = {};
        item.id = 0;
        item.name =  e[0].firstname;
        options.push(item);
        let objData: any = {};
        objData.id = 0;
        
        objData.name = e[0].firstname;
        Defaultselected.push(objData);
        this.state.formData.BuyerName = e[0].firstname;
        formData.BuyerName = e[0].firstname;

      }
    else
    {
      e[0].customerContact.forEach(element => {

        let item: any = {};
        item.id = element.id;
        item.name = element.firstname;
        options.push(item);

      });
    
     
      let defaultname: any = e[0].customerContact.filter(
        (x) => x.isDefault == true
      );

      
      if (defaultname.length > 0) {
        let objData: any = {};
        objData.id = defaultname[0].firstname;
        objData.name = defaultname[0].firstname;
        Defaultselected.push(objData);
        formData.BuyerName = defaultname[0].firstname;
        this.state.formData.BuyerName = defaultname[0].firstname;
      };

    }

      this.setState({
        Defaultselected: Defaultselected,
        options: options,
        CustomerName: e[0].company_name,
        address: e[0].address,
        customercode: e[0].customercode,
        isStateChanged: isStateChanged
      });
      this.state.formData.CustomerID = e[0].customer_id;

      this.state.formData.CustomerName = e[0].company_name;

      if (e[0].apartment != "") {
        this.state.formData.Address =
          // e[0].firstname +
          // " " +
          e[0].address +
          "\n" +
          e[0].apartment +
          "\n" +
          e[0].city +
          ", " +
          e[0].state +
          "\n" +
          e[0].zipcode +
          " " +
          e[0].country;
      }
      else {
        this.state.formData.Address =
          e[0].address +
          "\n" +
          e[0].city +
          ", " +
          e[0].state +
          "\n" +
          e[0].zipcode +
          " " +
          e[0].country;

      }
      this.state.formData.customercode = e[0].customercode;

      this.GetProductlist(requestlist);
      this.Previoustransactions();


      // this.GetorderEntryColoumn();


      let txtID = "txtOrderDate";
      // setTimeout(() => {
      //  // this.trDate.current.setOpen(true);
      // //  this.trpoDate.current.setOpen(true);
      //  // $("input[id^='" + txtID + "']").focus();
      // }, 50);


      // if (controlID === "txtExternalOrderDate") {
      //   this.trpoDate.current.setOpen(true);
      //   }
    } else {
    }
  };

  GetCustomerlist = (requestlist: any) => {
    CustomerService.GetCustomerlist(requestlist)
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({ customerList: result, isSpinner: false });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isSaveSpinner: false });
        reject();
      });
  };

  handleBlur = (event, rowIndex) => {
    if (event.key.toLowerCase() === "tab") {
      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );
      //orderData[rowIndex].amount = event.target.value === '' ? '' : !isNaN(event.target.value) ? Number(event.target.value).toFixed(2) : 0;
      this.setState({ orderData }, () => {
        if (orderData.length === rowIndex + 1) {

          this.handleNewRow();

          //  let len = this.state.orderData.length;
          // let txtID = "partno" + (len - 1) + "txt";
          // setTimeout(() => {
          // //  this.trDate.current.setOpen(true);
          //   $("input[id^='" + txtID + "']").focus();
          // //       $("#tblOrder")
          // // .find("input[class^='" + txtID + "']")
          // // .focus();
          // }, 50);
        }
      });
    }
  };

  handleDiscard(postID) {
    this.setState({ isStateChanged: false }, () => {
      this.closeSlideOut();
    });
  }

  onTAB = (control, rowIndex1, event) => {

    let controlID = control.split("-")[0];
    let rowIndex = Number(rowIndex1);


    // let txtID = "txtExternalOrderDate";
    // setTimeout(() => {
    //   this.trpoDate.current.setOpen(true);
    // //  this.trpoDate.current.setOpen(true);
    //   $("input[id^='" + txtID + "']").focus();
    // }, 50);
    if (event.key.toLowerCase() === "enter") {
      if (controlID === "txtOrderDate") {
        let txtID = "txtNotes";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      }
    }

    if (event.key.toLowerCase() === "tab") {

      let ChecktxtID = "partname" + rowIndex + "ddl";

      if (controlID === "partno") {
        this.setState({ isTab: 1 });
        //  let isStateChanged: any;
        //     isStateChanged = true;

        //     let orderDatan = Object.assign(
        //       [],
        //       JSON.parse(JSON.stringify(this.state.orderData))
        //     );
        //     let defaultPartnamen: any = [];
        //     let productListn = Object.assign(
        //       [],
        //       JSON.parse(JSON.stringify(this.state.productList))
        //     );

        //     let maxValueOfRow = Math.max(...productListn.map((o) => o.id), 0);
        //     let len = productListn.length;
        //     let maxRno = maxValueOfRow;

        //     if (event.target.value != "") {
        //       let objPartnamen: any = {};
        //       objPartnamen.id = Number(maxRno) + 1;
        //       objPartnamen.partno = orderDatan[rowIndex].partNo;
        //       objPartnamen.partname = event.target.value;
        //       //objPartnamen.label =e.target.value;

        //       objPartnamen.tenantid = 0;
        //       objPartnamen.unit = "";
        //       objPartnamen.unitPrice = 0;
        //       objPartnamen.noofday = null;
        //       objPartnamen.pdescription = "";
        //       objPartnamen.label = event.target.value;


        //       if (orderDatan[rowIndex].partNo != "" && event.target.value != "") {

        //         let partname2: any = productListn.filter(
        //           (x) => x.partno ==event.target.value
        //         );
        //         if (partname2.length > 0) {
        //           if (partname2[0].partname ==event.target.value && partname2[0].partNo == orderDatan[rowIndex].partNo) { }
        //           else {
        //             defaultPartnamen.push(objPartnamen);
        //             productListn.push(objPartnamen);
        //           }
        //         } else {
        //           defaultPartnamen.push(objPartnamen);
        //           productListn.push(objPartnamen);
        //         }

        //       }
        //       orderDatan[rowIndex].productid = objPartnamen;
        //       orderDatan[rowIndex].partname = event.target.value;
        //       orderDatan[rowIndex].defaultPartname = defaultPartnamen;

        //       //element.defaultPartname = defaultPartname;

        //       this.setState(
        //         { orderData: [], defaultPartname: [], productList: [] },
        //         () => {
        //           this.setState({
        //             orderData: orderDatan,
        //             defaultPartname: defaultPartnamen,
        //             productList: productListn,
        //             isStateChanged
        //           });

        //           // setTimeout(() => {

        //           //   let txtID1 = "txtduedate" + rowIndex + "txt";
        //           //        $("input[id^='" + txtID1 + "']").focus();
        //           // }, 50);
        //         }
        //       );

        //       // console.log(this.state.orderData);

        //       // console.log(this.state.productList);
        //     } else {
        //       let orderData = Object.assign(
        //         [],
        //         JSON.parse(JSON.stringify(this.state.orderData))
        //       );
        //       this.setState({ orderData: [] }, () =>
        //         this.setState({ orderData }, () => {
        //           // setTimeout(() => {

        //           //   let txtID1 = "txtduedate" + rowIndex + "txt";
        //           //       $("#tblOrder")
        //           //         .find("input[id^='" + txtID1 + "']")
        //           //         .focus();
        //           // }, 50);

        //         })
        //       );
        //     };

        // let txtID = "txtpartno" + rowIndex + "txt";

        // $("#tblOrder")
        //   .find("input[id^='" + txtID + "']")
        //   .focus();
          let txtID1 = "txtpartname" + rowIndex + "txt";
          setTimeout(() => {
         // $("input[id^='" + txtID1 + "']").focus();
                  $("#tblOrder")
                    .find("input[id^='" + txtID1 + "']")
                    .focus();
                  }, 50);



        // let txtID =
        //   "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
        // $("#tblOrder")
        //   .find("input[class^='" + txtID + "']")
        //   .focus();
      }

      if (controlID === "txtduedate") {
        let txtID = "txtdescription" + rowIndex + "txt";

        $("#tblOrder")
          .find("input[id^='" + txtID + "']")
          .focus();
      }

      if (controlID === "txtOrderDate") {
        let txtID = "txtNotes";
        setTimeout(() => {
          $("input[id^='" + txtID + "']").focus();
        }, 50);
      }
    }

    let start = event.target?.selectionStart;
    let end = event.target?.selectionEnd;
    if (event.key.toLowerCase() === "backspace") {
      this.setState({ pstart: start - 1, pend: end - 1 });
    }
    else
      this.setState({ pstart: start + 1, pend: end + 1 });

    // if (event.key.toLowerCase() === "backspace") {
    //   
    //   this.setState({isBack:1});

    //   let controlID = control.split("-")[0];

    //   if (controlID === "partname") {

    //     let rowIndex = Number(rowIndex1);
    //     let orderData = Object.assign(
    //       [],
    //       JSON.parse(JSON.stringify(this.state.orderData))
    //     );
    //     let defaultPartname: any = [];
    //     let productList = Object.assign(
    //       [],
    //       JSON.parse(JSON.stringify(this.state.productList))
    //     );

    //     orderData[rowIndex].partname =  event.target.value;
    //     //event.target.value;
    //     orderData[rowIndex].productid = 0;
    //     orderData[rowIndex].partNo = orderData[rowIndex].partNo;
    //     orderData[rowIndex].unitPrice = 0;
    //     orderData[rowIndex].unit = "";
    //     orderData[rowIndex].jobDesc = "";

    //     let objPartname: any = {};
    //     objPartname.partname = event.target.value;
    //     objPartname.label = event.target.value;
    //     objPartname.id = 0;
    //     objPartname.partno = orderData[rowIndex].partNo;
    //     objPartname.tenantid = 0;
    //     objPartname.unit = "";
    //     objPartname.unitPrice = 0;
    //     objPartname.noofday = null;
    //     objPartname.jobDesc = "";
    //     defaultPartname.push(objPartname);

    //     orderData[rowIndex].defaultPartname = defaultPartname;

    //     this.setState({ orderData, defaultPartname, productList }, () => {
    //       setTimeout(() => {

    //       let txtID =
    //         "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
    //       $("#tblOrder")
    //         .find("input[class^='" + txtID + "']")
    //         .focus();
    //       }, 50);
    //     });


    //   }
    // }
  };

  HidecloseSlideOut() {
    this.props.closeSlideOut();
    this.setState({ isSaveSpinner: false });
  }


  Hidespinner() {


    this.setState({ isSpinner: false });

  }

  saveOrderfinal = (entryType, isCopy, hideSlideOut = true) => {


    // if (orderRequestInProcess == true) {
    //   toast.error("Subsequent request has been made.", {
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //   });
    //   return;
    // }
    orderRequestInProcess = true;
    this.setState({ isSaveSpinner: true, isDisabled: true });
    if (entryType == "orderjob") {
      this.setState({ unsave: false, isSaveSpinner: true });
    }
    let orderlistItem: any = [];
    let isFormValid = true;
    let request: any = {};
    let isempty = 0;
    let isvalidate = 0;
    let isNegative = 0;
    let orderdata = this.state.orderData;
    orderdata.forEach(element => {
      let item: any = {};

      if (element.defaultPartname.length > 0) {
        if (element.partname == "") {

          isempty = 1;
        }

        item.Id = element.id;
        item.orderID = element.orderID;
        item.itemNo = element.itemNo;
        item.partname = element.partname;
        //element.partname[0].partname === undefined ? element.partname==undefined ? "" : element.partname  : element.partname[0].partname;
        item.partNo = element.partNo;
        item.dueDate = element.dueDate === "" || element.dueDate === undefined || element.dueDate === null ? new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime)) : Utils.toLocalISOString(new Date(element.dueDate));
        item.jobDesc = element.partname;
        // element.jobDesc;
        item.unit = element.unit;
        item.unitPrice = Utils.removecurrencyFormat(element.unitPrice);
        item.qtyOrdered = element.qtyOrdered;
        item.discount = Utils.removecurrencyFormat(element.discount);
        item.total = 0;
        //Utils.removecurrencyFormat(element.total);
        item.tenantid = element.tenantid;

        if (Utils.removecurrencyFormat(element.qtyOrdered) * Utils.removecurrencyFormat(element.unitPrice) - Utils.removecurrencyFormat(element.discount) < 0) {

          isNegative = 1;
        }

        if (new Date(item.dueDate) < new Date(this.state.formData.OrderDate)) {
          isvalidate = 1;
        }


        if (element.productid == 0) {
          item.productid = 0;
        }
        else {

          item.productid = 0;
        }
        orderlistItem.push(item);
      }
      else {

        isempty = 1;
      }



    });

    const partnames = new Set();
    let hasDuplicates = false;

    orderlistItem.forEach(item => {
      const partname = item.partname;
      if (partnames.has(partname)) {
        hasDuplicates = true;
      } else {
        partnames.add(partname);
      }
    });



    // if (hasDuplicates) {
    //   isFormValid = false;
    //   toast.error("Part Name should be unique", {
    //     position: toast.POSITION.BOTTOM_RIGHT,
    //     containerId: "OrderSlideout",
    //   });
    //   this.setState({ isSaveSpinner: false, isDisabled: false });
    //   return;
    // }

    this.state.formData.OrderItems = orderlistItem;

    this.state.formData.ExternalOrderDate = Utils.toLocalISOString(new Date(this.state.formData.ExternalOrderDate));
    this.state.formData.OrderDate = Utils.toLocalISOString(new Date(this.state.formData.OrderDate));

    request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));

    if (isNegative == 1) {
      isFormValid = false;
      toast.error("Total Amount should not negative.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return;
    }

    if (isvalidate == 1) {
      isFormValid = false;
      toast.error("Please check due date of parts.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return;
    }



    if (isempty == 1) {
      isFormValid = false;
      toast.error("Please select part.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      isempty = 0;
      // this.setState({ isSaveSpinner: false });
      return false;
    }

    if (request.customer_id === 0 && !isCopy) {
      toast.error("Please select Customer.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return false;
    }


    isFormValid = true;


    if (isFormValid) {
      this.setState({ saveRequest: request, ispopupshow: false });

      CustomerService.Saveorder(request)
        .then(async (result: any | null) => {
          if (result !== null) {
            // this.setState({ isSaveSpinner: false });
            if (this.state.orderid === 0) {
              this.setState({ orderid: result.orderID });
              toast.success(result.customerPoNumber + " order has been created.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OrderSlideout",
              });

              if (hideSlideOut)
                this.HidecloseSlideOut();
              else {
                //this.ShowJobModal(row.itemNo, row.productid, row.partname, row.partNo, row.qtyOrdered, row.poNumber, row.dueDate, row.jobDesc, row.id, row.jobid);
              }
            }
            else {

              toast.success("Order has been updated.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OrderSlideout",
              });

            }
            // this.setState({ isSaveSpinner: false },()=>{this.setState({ isSaveSpinner: false });});


            this.setState(
              {


              },
              () => {
                this.setState({ isSaveSpinner: false, isDisabled: false, isStateChanged: true });
                this.GetorderEntryColoumn();


              });

            // let requestlist = { ...this.state.requestlist };
            // this.GetProductlist(requestlist);

            // if(hideSlideOut)
            //   this.HidecloseSlideOut();
            // else
            // {
            //   //this.ShowJobModal(row.itemNo, row.productid, row.partname, row.partNo, row.qtyOrdered, row.poNumber, row.dueDate, row.jobDesc, row.id, row.jobid);
            // }

          }
          resolve();
          orderRequestInProcess = false;
        })
        .catch((error) => {
          this.setState({ isdefaultColDisabled: false, isSpinner: false });
          orderRequestInProcess = false;
          reject();
        });
    }
  };

  showprevious = () => {

    if (this.state.isprevious == false) {
      this.setState({ isprevious: true });
    }
    else {
      this.setState({ isprevious: false });
    }

  };


  saveOrder = (entryType, isCopy) => {

    if (this.state.savedfiles.length != 0 || this.state.newSelectfiles != 0) {
      this.setState({ ispopupshow: false, isSpinner: true });

      if (this.state.newSelectfiles.length > 0) {
        if (this.state.formData.CustomerID == 0 || this.state.formData.CustomerID == "") {
          this.setState({ isSpinner: false });
        }
        else {

          this.handleSaveFiles(this.state.newSelectfiles);
        }
      }
      else {

        this.saveOrderfinal("order", false, true);
      }

    }
    else {
      this.setState({ ispopupshow: true, isSpinner: true });

    }


  };

  isHandleAction() {
    // this.setState({ ispopupshow: false }, () => this.changeTransactionType(this.state.saveentryType, this.state.saverequest, false))
    //     request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
    //       this.state.formData.OrderItems=this.state.orderData;
    //    ispopupshow: false;
    //
    //    CustomerService.Saveorder(this.state.formData)
    //    .then(async (result: any | null) => {
    //        if (result !== null) {
    //            this.setState({ isdefaultColDisabled: false });
    //            if (result.saveStatus === "Success") {
    //                toast.success("saved for " + this.state.formData.vendorName + " successfully.", {
    //                    position: toast.POSITION.BOTTOM_RIGHT,
    //                    containerId: "OrderSlideout",
    //                });
    //            }
    //            else {
    //                toast.error(result.message, {
    //                    position: toast.POSITION.BOTTOM_RIGHT,
    //                    containerId: "OrderSlideout",
    //                });
    //            }
    //        }
    //        resolve();
    //    })
    //    .catch((error) => {
    //        this.setState({ isdefaultColDisabled: false });
    //        reject();
    //    });
  }


  handleSaveFiles(files: any) {
    // this.setState({ isSaveSpinner: true });

    //     let isFormValid = true;
    //     let request: any = {};
    //     let isNegative = 0;
    //     let orderdata = this.state.orderData;
    //     let orderlistItem: any = [];
    //     orderdata.forEach((element) => {
    //       let item: any = {};

    //       item.Id = element.id;
    //       item.orderID = element.orderID;
    //       item.itemNo = element.itemNo;
    //       item.partname =
    //         element.partname[0].partname === undefined
    //           ? element.partname
    //           : element.partname[0].partname;
    //       item.partNo = element.partNo;
    //       item.dueDate =
    //         element.dueDate === "" ||
    //           element.dueDate === undefined ||
    //           element.dueDate === null
    //           ? new Date()
    //           : element.dueDate;
    //       item.jobDesc = element.jobDesc;
    //       item.unit = element.unit;
    //       item.unitPrice =Utils.removecurrencyFormat(element.unitPrice);;
    //       item.qtyOrdered = element.qtyOrdered;
    //       item.discount = Utils.removecurrencyFormat(element.discount);
    //       item.total = 0; 
    //       //Utils.removecurrencyFormat(element.total);
    //       item.tenantid = element.tenantid;

    //       if ( Utils.removecurrencyFormat(element.qtyOrdered) *  Utils.removecurrencyFormat(element.unitPrice) -  Utils.removecurrencyFormat(element.discount) < 0) {

    //         isNegative = 1;
    //       }


    // if (isNegative == 1) {
    //     isFormValid = false;
    //     toast.error("Total Amount should not negative.", {
    //       position: toast.POSITION.BOTTOM_RIGHT,
    //       containerId: "OrderSlideout",
    //     });
    //     this.setState({ isSaveSpinner: false, isDisabled: false });
    //     return;
    //   }
    //       if (element.productid == 0) {
    //         item.productid = 0;
    //       } else {
    //         if (element.productid[0] == undefined) {
    //           item.productid = 0;
    //         } else {
    //           item.productid =
    //             element.productid[0].id === undefined
    //               ? element.productid
    //               : element.productid[0].id;
    //         }
    //       }

    //       orderlistItem.push(item);
    //     });

    //     this.state.formData.OrderItems = orderlistItem;
    //   // this.state.formData.ExternalOrderDate=new Date(this.state.formData.ExternalOrderDate);
    //     request = Object.assign(
    //       {},
    //       JSON.parse(JSON.stringify(this.state.formData))
    //     );

    //     if (request.customer_id === 0) {
    //       toast.error("Please select Customer.", {
    //         position: toast.POSITION.BOTTOM_RIGHT,
    //         containerId: "OrderSlideout",
    //       });

    //       return false;
    //     }

    //     isFormValid = true;

    let orderlistItem: any = [];
    let isFormValid = true;
    let request: any = {};
    let isempty = 0;
    let isNegative = 0;
    let orderdata = this.state.orderData;
    orderdata.forEach(element => {
      let item: any = {};

      if (element.defaultPartname.length > 0) {
        if (element.partname == "") {

          isempty = 1;
        }

        item.Id = element.id;
        item.orderID = element.orderID;
        item.itemNo = element.itemNo;
        item.partname = element.partname;
        //element.partname[0].partname === undefined ? element.partname==undefined ? "" : element.partname  : element.partname[0].partname;
        item.partNo = element.partNo;
        item.dueDate = element.dueDate === "" || element.dueDate === undefined || element.dueDate === null ? new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime)) : element.dueDate;
        item.jobDesc = element.partname;
        // element.jobDesc;
        item.unit = element.unit;
        item.unitPrice = parseFloat(Number(Utils.removecurrencyFormat(element.unitPrice)).toFixed(2));
        item.qtyOrdered = element.qtyOrdered;
        item.discount = parseFloat(Number(Utils.removecurrencyFormat(element.discount)).toFixed(2));
        item.total = parseFloat(Number(Utils.removecurrencyFormat(element.unitPrice)).toFixed(2));
        //Utils.removecurrencyFormat(element.total);
        item.tenantid = element.tenantid;

        if (Utils.removecurrencyFormat(element.qtyOrdered) * Utils.removecurrencyFormat(element.unitPrice) - Utils.removecurrencyFormat(element.discount) < 0) {

          isNegative = 1;
        }


        if (element.productid == 0) {
          item.productid = 0;
        }
        else {
          // if (element.productid[0] == undefined) {
          //   item.productid = element.productid;

          // }
          // else {
          //   item.productid = element.productid[0].id === undefined ? element.productid : element.productid[0].id;
          // }
          item.productid = 0;
        }
        orderlistItem.push(item);
      }
      else {

        isempty = 1;
      }



    });
debugger;
    this.state.formData.OrderItems = orderlistItem;
 
    this.state.formData.ExternalOrderDate = moment(this.state.formData.ExternalOrderDate).format("MM/DD/YYYY");
    this.state.formData.OldOrderID = 0;
    this.state.formData.UserName = "";

    request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));

    if (isNegative == 1) {
      isFormValid = false;
      toast.error("Total Amount should not negative.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return;
    }

    if (isempty == 1) {
      isFormValid = false;
      toast.error("Please select part.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      isempty = 0;
      // this.setState({ isSaveSpinner: false });
      return false;
    }

    if (request.customer_id === 0) {
      toast.error("Please select Customer.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSaveSpinner: false, isDisabled: false });
      return false;
    }


    isFormValid = true;


    if (isFormValid) {

      this.setState({ saveRequest: request });

      CustomerService.Savefiles(request, files)
        .then(async (result: any | null) => {
          if (result !== null) {
            debugger;

            if(result=="PDF header signature not found.")
            {


              toast.success(result, {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OrderSlideout",
              });
              this.setState(
                {
    
    
                },
                () => {
                  this.setState({ isSaveSpinner: false, isDisabled: false, isStateChanged: true });
                  this.GetorderEntryColoumn();
    
    
                });
            }
            else
            {
            this.GetUploadFileList(result.orderID, 1);
            if (this.state.orderid === 0) {
              toast.success(
                result.customerPoNumber + " order has been created.",
                {
                  position: toast.POSITION.BOTTOM_RIGHT,
                  containerId: "OrderSlideout",
                }
              );
            } else {
              toast.success("Order has been updated.", {
                position: toast.POSITION.BOTTOM_RIGHT,
                containerId: "OrderSlideout",
              });
            }
          //  this.HidecloseSlideOut();

          this.setState(
            {


            },
            () => {
              this.setState({ isSaveSpinner: false, isDisabled: false, isStateChanged: true });
              this.GetorderEntryColoumn();


            });
          }
          }
          resolve();
        })
        .catch((error) => {
          this.setState({ isdefaultColDisabled: false });
          reject();
        });
    }
  }

  GetUploadFileList = (uniqueNo, type) => {
    let requestlist: any = {};

    requestlist.orderid = uniqueNo;

    CustomerService.GetUploadFileWithFileCode(requestlist)
      .then(async (result: any | null) => {
        if (result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            this["myRef" + i] = React.createRef();
          }
          let filelist: any[] = [];
          result.forEach((element, i) => {
            element.fileCode =
              "data:application/pdf;base64," + element.fileCode;
            element.fileName = element.name;
            element.newname = element.name.toString().toLowerCase();
            filelist.push(element);
          });
          //filelist = _.sortBy(filelist, "newname");
          this.setState({savedfiles:[]}, () => {
            this.setState(
              (prevState) => ({
                savedfiles: filelist,
                isAttachmentLoading: false,
                isOpenViewer: false,
                newSelectedfiles: [],
                files: [],
                bulkSelect: true,
              }),
              () => {
                setTimeout(() => {
                  this.scrollheight.current?.getElement().scrollTo({
                    top: Number(this.state.currentScreenTop),
                    behavior: "smooth",
                  });
                }, 500);
              }
            );
          }


          );
         
        
        } else {
          this.setState({
            isOpenViewer: false,
            savedfiles: [],
            newSelectedfiles: [],
            files: [],
            bulkSelect: false,
          });
        }

        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({
          isOpenViewer: false,
          savedfiles: [],
          newSelectedfiles: [],
          files: [],
          bulkSelect: false,
        });
      });
  };

  hoverOutEllipsis = () => {
    $(".tooltip").removeClass("show");
  };
  hoverOutEllipsis1 = () => {

    //  $("#order").removeClass("table-responsive");
  };

  amountBlur = (e, rowIndex, type: any) => {

    let orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    if (e.target.value.includes(".")) {
      const timeArray = e.target.value?.split(".");
      if (timeArray[1].length <= 0) {
        if (type === "unitPrice") {
          orderData[rowIndex].unitPrice = Utils.currencyFormat(
            timeArray[0]
          ); //Number(timeArray[0]).toFixed(2);
        }
        if (type === "discount") {
          orderData[rowIndex].discount = Utils.currencyFormat(
            timeArray[0]
          ); //Number(timeArray[0]).toFixed(2);
        }
        if (type === "qtyOrdered") {
          orderData[rowIndex].qtyOrdered = Utils.currencyFormat(
            timeArray[0]
          ); //Number(timeArray[0]).toFixed(2);
        }
      } else {
        if (type === "unitPrice") {
          orderData[rowIndex].unitPrice = Utils.currencyFormat(
            e.target.value
          );
        }
        if (type === "discount") {
          orderData[rowIndex].discount = Utils.currencyFormat(
            e.target.value
          );
        }
        if (type === "qtyOrdered") {
          orderData[rowIndex].qtyOrdered = Utils.currencyFormat(
            e.target.value
          );
        }
      }

      this.setState({ orderData });
    } else {
      if (type === "unitPrice") {
        orderData[rowIndex].unitPrice =
          e.target.value === ""
            ? ""
            : !isNaN(e.target.value)
              ? Utils.currencyFormat(e.target.value)
              : e.target.value;
      }
      if (type === "discount") {
        orderData[rowIndex].discount =
          e.target.value === ""
            ? ""
            : !isNaN(e.target.value)
              ? Utils.currencyFormat(e.target.value)
              : e.target.value;
      }
      this.setState({ orderData });
    }
  };

  onAmountFocus = (e, index, txtID, type: any) => {

    let orderData = Object.assign([], JSON.parse(JSON.stringify(this.state.orderData)));
    //let newval = Utils.removecurrencyFormat(e.target.value);
    let start = e.target?.selectionStart;
    let end = e.target?.selectionEnd;
    if (type === "unitPrice") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      orderData[index].unitPrice = e.target.value;

      this.setState({ orderData }, () => {
        $("#tblOrder")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tblOrder").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }

    if (type === "discount") {
      let newVal = Utils.removeInvaildCharFromAmount(e.target.value);
      e.target.value = newVal;
      orderData[index].discount = e.target.value;

      this.setState({ orderData }, () => {
        $("#tblOrder")
          .find("input[id^='" + txtID + "']")
          .focus();
        let txtdesc = $("#tblOrder").find(
          "input[id^='" + txtID + "']"
        )[0] as any;
        if (txtdesc !== null && txtdesc !== undefined) {
          txtdesc.selectionStart = start;
          txtdesc.selectionEnd = end;
        }
      });
    }


    // this.setState({ orderData }, () => {
    //     $("#tblOrder").find("input[id^='" + txtID + "']").focus();
    // });
  };
  handleSelectedItem = (control: any, id: any) => {



    if (this != undefined) {


      let isStateChanged = true;
      // $("#order").removeClass("table-responsive");
      let formData = { ...this.state.formData };
      let controlID = Number(control.split("_")[0]);
      let rowIndex = Number(control.split("_")[1]);

      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );
      let defaultPartname: any = [];
      let productList = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.productList))
      );
      if (controlID === 1) {

        if (id.length > 0 && this.state.isTab == 0) {
          if (id[0].id > 0) {

            orderData[rowIndex].partname = id[0].partname;
            orderData[rowIndex].productid = id;

            orderData[rowIndex].partNo = id[0].partno;
            orderData[rowIndex].unitPrice = id[0].unitPrice;
            orderData[rowIndex].unit = id[0].unit;
            orderData[rowIndex].jobDesc = id[0].pdescription;
            orderData[rowIndex].defaultPartname = id[0].partname;
            let objPartname: any = {};
            objPartname.partname = id[0].partname;
            objPartname.label = id[0].partno;
            objPartname.id = id;
            objPartname.partno = id[0].partno;

            objPartname.tenantid = 0;
            objPartname.unit = id[0].unit;
            objPartname.unitPrice = id[0].unitPrice;
            objPartname.noofday = null;
            objPartname.jobDesc = id[0].pdescription;
            defaultPartname.push(objPartname);
            //element.defaultPartname = defaultPartname;
            orderData[rowIndex].defaultPartname = defaultPartname;
            // this.setState(
            //   { orderData, defaultPartname, productList, isStateChanged },
            //   () => {
            //     //let txtID = "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
            //     ///$("input[class^='" + txtID + "']").focus();
            //     // let txtID = "txtpartno" + rowIndex + "txt";
            //     // $("#tblOrder")
            //     //   .find("input[id^='" + txtID + "']")
            //     //   .focus();

            //     let txtID1 = "txtduedate" + rowIndex + "txt";
            //     $("#tblOrder")
            //       .find("input[id^='" + txtID1 + "']")
            //       .focus();
            //   }
            // );
          } else {

            orderData[rowIndex].partname = id[0].label;
            orderData[rowIndex].productid = 0;
            orderData[rowIndex].partNo = orderData[rowIndex].partNo;
            orderData[rowIndex].unitPrice = 0;
            orderData[rowIndex].unit = "";
            orderData[rowIndex].jobDesc = "";
            orderData[rowIndex].defaultPartname = id[0].label;
            let objPartname: any = {};
            objPartname.partname = id[0].label;
            objPartname.label = id[0].label;
            objPartname.id = 0;
            objPartname.partno = orderData[rowIndex].partNo;

            objPartname.tenantid = 0;
            objPartname.unit = "";
            objPartname.unitPrice = 0;
            objPartname.noofday = null;
            objPartname.jobDesc = "";
            defaultPartname.push(objPartname);
            // productList.push(objPartname);

            //element.defaultPartname = defaultPartname;
            orderData[rowIndex].defaultPartname = id;

            this.setState(
              { orderData, defaultPartname, productList, isStateChanged, isTab: 0 },
              () => {
                //let txtID = "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
                ///$("input[class^='" + txtID + "']").focus();
                // let txtID = "txtpartno" + rowIndex + "txt";
                // $("#tblOrder")
                //   .find("input[id^='" + txtID + "']")
                //   .focus();
                let txtID1 = "txtduedate" + rowIndex + "txt";
                $("#tblOrder")
                  .find("input[id^='" + txtID1 + "']")
                  .focus();
              }
            );
          }
          this.setState(
            { orderData, defaultPartname, productList, isStateChanged, isTab: 0 },
            () => {

              if (this.state.isBack == 0) {
                let txtID1 = "txtduedate" + rowIndex + "txt";
                $("#tblOrder")
                  .find("input[id^='" + txtID1 + "']")
                  .focus();
              }
              // let txtID =
              //   "rbt-input-main form-control rbt-input form-control form-control-sm partname" +
              //   rowIndex +
              //   "ddl";
              // $("input[class^='" + txtID + "']").focus();
              // let txtID = "rbt-input-main form-control rbt-input partno" + rowIndex + "ddl";
              // $("input[class^='" + txtID + "']").focus();
              //   let txtID = "txtpartno" + rowIndex + "txt";
              // $("#tblOrder").find("input[id^='" + txtID + "']").focus();
            }
          );
        }
        else {

          // console.log("handle seleted " + id);
          // let txtID1= "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
          //  let pname=  $("input[class^='" + txtID1 + "']").val();

          setTimeout(() => {
            // orderData[rowIndex].partname = this.state.partnamevalue;
            orderData[rowIndex].partname = orderData[rowIndex].partname;
            orderData[rowIndex].productid = 0;
            // orderData[rowIndex].partNo = orderData[rowIndex].partNo;
            orderData[rowIndex].partNo = this.state.partnamevalue;
            orderData[rowIndex].unitPrice = 0;
            orderData[rowIndex].unit = "";
            orderData[rowIndex].jobDesc = "";

            let objPartname: any = {};
            // objPartname.partname = this.state.partnamevalue;
            objPartname.partname = orderData[rowIndex].partname;
            objPartname.label = this.state.partnamevalue;;
            objPartname.id = 0;
            objPartname.partno = orderData[rowIndex].partNo;

            objPartname.tenantid = 0;
            objPartname.unit = "";
            objPartname.unitPrice = 0;
            objPartname.noofday = null;
            objPartname.jobDesc = "";
            defaultPartname.push(objPartname);
            // productList.push(objPartname);

            //element.defaultPartname = defaultPartname;
            orderData[rowIndex].defaultPartname = defaultPartname;
            this.setState(
              { orderData, defaultPartname, productList, isStateChanged, isTab: 0 },
              () => {

                let txtID =
                  "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
                $("#tblOrder").find("input[class^='" + txtID + "']").focus();
                let txtdesc = $("#tblOrder").find("input[class^='" + txtID + "']") as any;  //$('.partname0ddl')

                if (this.state.pstart > 0 && this.state.pend > 0) {
                  //txtdesc.get(0).setSelectionRange(this.state.pstart-1, this.state.pend-1);
                  let input = txtdesc.get(0);
                  if (input.setSelectionRange) {
                    input.setSelectionRange(this.state.pstart, this.state.pend);
                  }
                  // For older browsers
                  else if (input.createTextRange) {
                    var range = input.createTextRange();
                    range.collapse(true);
                    range.moveEnd('character', this.state.pend);
                    range.moveStart('character', this.state.pstart);
                    range.select();
                  }

                } else {
                  let input = txtdesc.get(0);

                  if (input.setSelectionRange) {
                    input.setSelectionRange(0, 0);
                  } else if (input.createTextRange) {
                    // Older browsers
                    let range = input.createTextRange();
                    range.collapse(true);
                    range.moveStart('character', 0);
                    range.select();
                  }

                }
                //let txtID = "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl";
                // $("input[class^='" + txtID + "']").focus();
                // let txtID =
                //   "rbt-input-main form-control rbt-input form-control form-control-sm partname" +
                //   rowIndex +
                //   "ddl";
                // $("input[class^='" + txtID + "']").focus();
                // let txtID = "rbt-input-main form-control rbt-input partno" + rowIndex + "ddl";
                // $("input[class^='" + txtID + "']").focus();
                //   let txtID = "txtpartno" + rowIndex + "txt";
                // $("#tblOrder").find("input[id^='" + txtID + "']").focus();
              }
            );
          }, 5);
        }

        //  let id = "txtpartno" + rowIndex + "txt";

      }

    }
  };


  onInputChange = (e: any, id: any, control: any) => {


    this.setState({ partnamevalue: e });
  };

  // handleOutsideClick = (rowIndex: any, e: any) => {
  // };
  handleOutsideClick = (rowIndex: any, e: any) => {



    //let responsive = "table-responsiveadd" ;
    let isStateChanged: any;
    isStateChanged = true;
    // $("#order").addClass("table-responsive");
    let btnId = "partname" + rowIndex + "btn";
    let id = "partname" + rowIndex + "ddl";
    let relatedTargetID = e.relatedTarget?.id;
    let relatedTargettagName = e.relatedTarget?.tagName;

    let orderDatan = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );
    let defaultPartnamen: any = [];
    let productListn = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.productList))
    );

    let maxValueOfRow = Math.max(...productListn.map((o) => o.id), 0);
    let len = productListn.length;
    let maxRno = maxValueOfRow;

    if (e.target.value != "") {
      let objPartnamen: any = {};
      objPartnamen.id = Number(maxRno) + 1;
      // objPartnamen.partno = orderDatan[rowIndex].partNo;
      // objPartnamen.partname = e.target.value;
      objPartnamen.partno = e.target.value;
      objPartnamen.partname = orderDatan[rowIndex].partname;
      //objPartnamen.label =e.target.value;

      objPartnamen.tenantid = 0;
      objPartnamen.unit = "";
      objPartnamen.unitPrice = 0;
      objPartnamen.noofday = null;
      objPartnamen.pdescription = "";
      objPartnamen.label = e.target.value;


      if (e.target.value != "") {

        let partname2: any = productListn.filter(
          (x) => x.partno == e.target.value
        );
        if (partname2.length > 0) {
          // if (partname2[0].partname == e.target.value && partname2[0].partNo == orderDatan[rowIndex].partNo) { }
          if (partname2[0].partname == orderDatan[rowIndex].partname && partname2[0].partNo == e.target.value) { }

          else {
            defaultPartnamen.push(objPartnamen);
            productListn.push(objPartnamen);
          }
        } else {
          defaultPartnamen.push(objPartnamen);
          productListn.push(objPartnamen);
        }

      }
      orderDatan[rowIndex].productid = objPartnamen;
      orderDatan[rowIndex].partNo = e.target.value;
      orderDatan[rowIndex].defaultPartname = defaultPartnamen;

      //element.defaultPartname = defaultPartname;

      this.setState(
        { orderData: [], defaultPartname: [], productList: [] },
        () => {
          this.setState({
            orderData: orderDatan,
            defaultPartname: defaultPartnamen,
            productList: productListn,
            isStateChanged
          });

          // setTimeout(() => {

          //   let txtID1 = "txtduedate" + rowIndex + "txt";
          //        $("input[id^='" + txtID1 + "']").focus();
          // }, 50);
        }
      );

      // console.log(this.state.orderData);

      // console.log(this.state.productList);
    } else {
      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );
      this.setState({ orderData: [] }, () =>
        this.setState({ orderData }, () => {
          // setTimeout(() => {

          //   let txtID1 = "txtduedate" + rowIndex + "txt";
          //       $("#tblOrder")
          //         .find("input[id^='" + txtID1 + "']")
          //         .focus();
          // }, 50);

        })
      );
    }

    $("#tblOrder")
      .find("button[id^='" + btnId + "']")
      .css("display", "block");
    $("#tblOrder")
      .find("div[id^='" + id + "']")
      .css("display", "none");
    setTimeout(() => {
      if (relatedTargetID === undefined) {
        // setTimeout(() => {

        //   let txtID1 = "txtduedate" + rowIndex + "txt";
        //       $("#tblOrder")
        //         .find("input[id^='" + txtID1 + "']")
        //         .focus();
        // }, 50);

      } else if (
        relatedTargetID ===
        "rbt-input-main form-control rbt-input form-control form-control-sm partname" + rowIndex + "ddl"
      ) {
        let txtID1 =
          "rbt-input-main form-control rbt-input form-control form-control-sm partname" +
          rowIndex +
          "ddl";
        $("#tblOrder")
          .find("input[class^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtpartno" + rowIndex + "txt") {
        let txtID1 = "txtpartno" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtduedate" + rowIndex + "txt") {
        let txtID1 = "txtduedate" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtdescription" + rowIndex + "txt") {
        let txtID1 = "txtdescription" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtunit" + rowIndex + "txt") {
        let txtID1 = "txtunit" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtqty" + rowIndex + "txt") {
        let txtID1 = "txtqty" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtunitprice" + rowIndex + "txt") {
        let txtID1 = "txtunitprice" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txtdiscount" + rowIndex + "txt") {
        let txtID1 = "txtdiscount" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      } else if (relatedTargetID === "txttotal" + rowIndex + "txt") {
        let txtID1 = "txttotal" + rowIndex + "txt";
        $("#tblOrder")
          .find("input[id^='" + txtID1 + "']")
          .focus();
      }

    }, 50);
  };


  // updateStateblur = (e: any, index: any, type: any, txtID) => {
  //   if (type === "partNo") {
  //     let txtID =
  //     "rbt-input-main form-control rbt-input form-control form-control-sm partname" + index + "ddl";

  //       $("input[class^='" + txtID + "']").focus();

  //   }
  // };
  updateStateblur = (e: any, index: any, type: any, txtID) => {
    if (this != undefined) {

      // let responsive = "table-responsiveadd" ;
      let isStateChanged = true;
      let start = e.target?.selectionStart;
      let end = e.target?.selectionEnd;
      let orderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.orderData))
      );


      if (type === "partNo") {
        e.preventDefault();

        let productList = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.productList))
        );

        if (this.state.productList.length == undefined || this.state.productList.length == 0) {

          let requestlist = { ...this.state.requestlist };

          requestlist.customerid = this.state.formData.CustomerID;



          ProductService.GetProductOrderlist(requestlist)
            .then(async (result: any | null) => {
              if (result !== null) {
                this.setState({ orderData: [] }, () => {
                  this.setState(
                    {
                      orderData: orderData,
                      productList: result

                    },
                    () => {
                      let partname: any = this.state.productList.filter(
                        (x) => x.partno.toLowerCase() == e.target.value.toLowerCase()
                      );
                      if (partname.length > 0) {



                        let defaultPartname: any = [];
                        let objPartname: any = {};
                        objPartname.partname = partname[0].partname;
                        objPartname.label = partname[0].partname;
                        objPartname.id = partname[0].productid;

                        objPartname.partno = partname[0].partNo;

                        objPartname.tenantid = 0;
                        objPartname.unit = partname[0].unit;
                        objPartname.unitPrice = partname[0].unitPrice;
                        objPartname.noofday = null;
                        objPartname.jobDesc = partname[0].jobDesc;

                        defaultPartname.push(objPartname);

                        orderData[index].defaultPartname = defaultPartname;

                        orderData[index].partname = partname[0].partname;

                        if (partname[0].partname != "") {
                          orderData[index].isdisabled = true;
                        }
                        // alert(partname[0].partname);
                      }
                      else {
                        let defaultPartname: any = [];
                        let objPartname: any = {};
                        objPartname.partname = orderData[index].partname == "" ? objPartname.partname : orderData[index].partname;
                        objPartname.label = orderData[index].partname == "" ? objPartname.partname : orderData[index].partname;
                        objPartname.id = 0;

                        objPartname.partno = e.target.value;

                        objPartname.tenantid = 0;
                        objPartname.unit = 0;
                        objPartname.unitPrice = 0;
                        objPartname.noofday = null;
                        objPartname.jobDesc = "";



                        if (orderData[index].partname != "" && e.target.value != "") {
                          let partname1: any = productList.filter(
                            (x) => x.partno.toLowerCase() == e.target.value.toLowerCase()
                          );
                          if (partname1.length > 0) {
                            if (partname1[0].partname == orderData[index].partname && partname1[0].partNo == e.target.value) { }
                            else {
                              defaultPartname.push(objPartname);

                              productList.push(objPartname);
                            }
                          }
                          else {
                            defaultPartname.push(objPartname);

                            productList.push(objPartname);
                          }
                        }
                        orderData[index].defaultPartname = defaultPartname;
                        // orderData[index].isdisabled = false;
                        //  orderData[index].partname = "";
                      }
                    }
                  );
                });
              }
              resolve();
            })
            .catch((error) => {
              this.setState({ isSpinner: false });
              reject();
            });
        }
        else {
          let partname: any = this.state.productList.filter(
            (x) => x.partno == e.target.value
          );
          if (partname.length > 0) {



            let defaultPartname: any = [];
            let objPartname: any = {};
            objPartname.partname = partname[0].partname;
            objPartname.label = partname[0].partname;
            objPartname.id = partname[0].productid;

            objPartname.partno = partname[0].partNo;

            objPartname.tenantid = 0;
            objPartname.unit = partname[0].unit;
            objPartname.unitPrice = partname[0].unitPrice;
            objPartname.noofday = null;
            objPartname.jobDesc = partname[0].jobDesc;

            defaultPartname.push(objPartname);

            orderData[index].defaultPartname = defaultPartname;

            orderData[index].partname = partname[0].partname;

            // if (partname[0].partname != "") {
            //   orderData[index].isdisabled = true;
            // }
            // alert(partname[0].partname);
          }
          else {
            let defaultPartname: any = [];
            let objPartname: any = {};
            objPartname.partname = orderData[index].partname == "" ? objPartname.partname : orderData[index].partname;
            objPartname.label = orderData[index].partname == "" ? objPartname.partname : orderData[index].partname;
            objPartname.id = 0;

            objPartname.partno = e.target.value;

            objPartname.tenantid = 0;
            objPartname.unit = 0;
            objPartname.unitPrice = 0;
            objPartname.noofday = null;
            objPartname.jobDesc = "";


            if (orderData[index].partname != "" && e.target.value != "") {
              let partname1: any = productList.filter(
                (x) => x.partno.toLowerCase() == e.target.value.toLowerCase()
              );
              if (partname1.length > 0) {
                if (partname1[0].partname == orderData[index].partname && partname1[0].partNo == e.target.value) { }
                else {
                  defaultPartname.push(objPartname);

                  productList.push(objPartname);
                }
              }
              else {
                defaultPartname.push(objPartname);

                productList.push(objPartname);

              }
            }
            orderData[index].defaultPartname = defaultPartname;
            //orderData[index].isdisabled = false;
            //orderData[index].partname = orderData[index].partname;
          }

        }



        orderData[index].partNo = e.target.value;

        let partname: any = this.state.productList.filter(
          (x) => x.partno == e.target.value
        );
        if (partname.length > 0) {



          let defaultPartname: any = [];
          let objPartname: any = {};
          objPartname.partname = partname[0].partname;
          objPartname.label = partname[0].partname;
          objPartname.id = partname[0].productid;

          objPartname.partno = partname[0].partNo;

          objPartname.tenantid = 0;
          objPartname.unit = partname[0].unit;
          objPartname.unitPrice = partname[0].unitPrice;
          objPartname.noofday = null;
          objPartname.jobDesc = partname[0].jobDesc;

          defaultPartname.push(objPartname);

          orderData[index].defaultPartname = defaultPartname;

          orderData[index].partname = partname[0].partname;
          // if (partname[0].partname != "") {
          //   orderData[index].isdisabled = true;
          // }
          // alert(partname[0].partname);
        }
        else {
          let defaultPartname: any = [];
          let objPartname: any = {};
          objPartname.partname = orderData[index].partname == "" ? objPartname.partname : orderData[index].partname;
          objPartname.label = orderData[index].partname == "" ? objPartname.partname : orderData[index].partname;
          objPartname.id = 0;

          objPartname.partno = e.target.value;

          objPartname.tenantid = 0;
          objPartname.unit = 0;
          objPartname.unitPrice = 0;
          objPartname.noofday = null;
          objPartname.jobDesc = "";


          if (orderData[index].partname != "" && e.target.value != "") {
            let partname1: any = productList.filter(
              (x) => x.partno.toLowerCase() == e.target.value.toLowerCase()
            );
            if (partname1.length > 0) {
              if (partname1[0].partname == orderData[index].partname && partname1[0].partNo == e.target.value) { }
              else {
                defaultPartname.push(objPartname);

                productList.push(objPartname);
              }
            }
            else {
              defaultPartname.push(objPartname);

              productList.push(objPartname);

            }
          }
          orderData[index].defaultPartname = defaultPartname;
          // orderData[index].isdisabled = false;
          orderData[index].partname = orderData[index].partname;
        }


        this.setState(
          { orderData, productList, isStateChanged },
          () => {



            let len = this.state.orderData.length;

            let txtID =
              "rbt-input-main form-control rbt-input form-control form-control-sm partname" + (len - 1) + "ddl";
            $("#tblOrder")
              .find("input[class^='" + txtID + "']")
              .focus();


            // let txtID =
            //   "rbt-input-main form-control rbt-input form-control form-control-sm partname" +
            //   index +
            //   "ddl";
            // $("input[class^='" + txtID + "']").focus();
            // let txtID = "rbt-input-main form-control rbt-input partno" + rowIndex + "ddl";
            // $("input[class^='" + txtID + "']").focus();
            //   let txtID = "txtpartno" + rowIndex + "txt";
            // $("#tblOrder").find("input[id^='" + txtID + "']").focus();
          }
        );
        // this.setState({ orderData, productList, isStateChanged }, () => {
        //   // $("#tblOrder")
        //   //   .find("input[id^='" + txtID + "']")
        //   //   .focus();
        //   // let txtdesc = $("#tblOrder").find(
        //   //   "input[id^='" + txtID + "']"
        //   // )[0] as any;
        //   // if (txtdesc !== null && txtdesc !== undefined) {
        //   //   txtdesc.selectionStart = start;
        //   //   txtdesc.selectionEnd = end;
        //   // }
        // });
      }

    }
  };

  // handleCOAFocus = (ddlID, rowIndex) => {
  //   let orderData = Object.assign(
  //     [],
  //     JSON.parse(JSON.stringify(this.state.orderData))
  //   );

  //   this.setState({ orderData: [] }, () =>
  //     this.setState({ orderData }, () => {
  //       $("input[class^='" + ddlID + "']").focus();
  //     })
  //   );
  // };

  handleCOAFocus = (btnID, txtID, ddlID, rowIndex) => {

    let orderData = Object.assign([], JSON.parse(JSON.stringify(this.state.orderData)));

    this.setState({ orderData: [] }, () => this.setState({ orderData }, () => {
      $("input[class^='" + ddlID + "']").focus();
    }));
    // $("#tblSplit").find("button[id^='" + btnID + "']").css("display", 'none');
    // $("#tblSplit").find("div[id^='" + txtID + "']").css("display", 'block');

  };
  Previoustransactions() {
    this.setState((prevState) => ({
      isPreviousTransactions: !prevState.isPreviousTransactions,
    }));

    let requestlistprev = { ...this.state.requestlistprev };
    //requestlistprev.recordCount = 5;
    this.GetPreviousTransactionList(requestlistprev);
    this.setState({ requestlistprev });
  }

  GetPreviousTransactionList = (requestlistprev: any) => {
    // requestlist.customerid = this.state.formData.CustomerID;

    //requestlist.tenantid = this.state.tenantid;
    let saveRequest: any = {};
    saveRequest.customerid = this.state.formData.CustomerID;
    saveRequest.tenantid = 0;
    saveRequest.recordCount = requestlistprev.recordCount;
    saveRequest.search = requestlistprev.search;
    CustomerService.GetPreviousCustomerOrder(saveRequest)
      .then(async (result: any | null) => {
        if (result !== null) {

          let totalCount = 0;
          if (result.filter((x) => x.orderID != this.state.orderid).length > 0) {
            totalCount = result.filter((x) => x.orderID != this.state.orderid)[0].totalCount;
          }

          this.setState({ previousOrderData: result.filter((x) => x.orderID != this.state.orderid), totalCount: totalCount });
        }
        resolve();
      })
      .catch((error) => {
        reject();
        // this.setState({ isSaveSpinner: false});
      });
  };

  showMore = () => {

    //let requestlistprev = { ...this.state.requestlistprev };
    //requestlistprev.recordCount = Number(requestlistprev.recordCount) + 5;
    //this.loadPreviousData();

    this.setState({ displayRecordCount: (this.state.displayRecordCount + 5) });
  };

  loadPreviousData() {

    let requestlistprev = { ...this.state.requestlistprev };
    let loadrecord = requestlistprev.recordCount;
    //requestlistprev.recordCount = Number(requestlistprev.recordCount) + 5;
    requestlistprev.search = this.state.searchPreviousData;
    //if (Number(loadrecord) <= Number(this.state.totalCount) || this.state.searchPreviousData != '') {
    this.GetPreviousTransactionList(requestlistprev);
    this.setState({ requestlistprev });
    // }
    //    else {
    //        toast.error("No previous order exist.", {
    //          position: toast.POSITION.BOTTOM_RIGHT,
    //           containerId: "Customerorderslideout",
    //        });
    //      }
  }

  AddedRow = (e) => {
    this.setState({ isSaveSpinner: false });
    this.setState({ Isadded: true });
    this.setState({ isDuplicate: false });
    this.handleRowSelection(e, this.state.rowData, this.state.Orderid);
  };
  CancelRow = (e) => {
    this.setState({ isSaveSpinner: false });
    this.setState({ Isadded: false });
    this.setState({ isDuplicate: false });
  };

  Cancelunsave = (e) => {

    this.setState({ unsave: false });
  };

  handleRowSelectionCheck = (e, rowData, Orderid, isAll) => {
    let orderData: any = [];

    orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    let previousOrderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.previousOrderData))
    );

    if (this != undefined) {
      let orderArray: any = [];

      orderArray = previousOrderData.filter(
        (x) => x.orderID === Orderid && x.mainType == 2
      );

      let orderlist: any = [];
      if (orderArray.length > 0) {
        orderArray.forEach((element: any, index: any) => {
          if (rowData === index) {
            let orderDatacheck = this.state.orderData.filter(
              (x) =>
                x.productid === element.productid ||
                x.partname === element.partname
            );
            if (orderDatacheck.length > 0) {
              this.setState({
                isDuplicate: true,
                Isadded: false,
                Orderid: Orderid,
                rowData: rowData,
              });
            } else {
              if (isAll === "all") {
                this.handleRowSelectionn(e, 0, Orderid);
              } else {
                this.handleRowSelection(e, rowData, Orderid);
              }
            }
          }
        });
      }
    }
  };

  handleRowSelectionCheckAll = (e, Orderid) => {
    if (this != undefined) {
      let prevorderid = this.state.prevOrderidselected;

      let orderArray: any = [];
      let previousOrderData: any = [];
      previousOrderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.previousOrderData))
      );
      orderArray = previousOrderData.filter(
        (x) => x.orderID === prevorderid && x.mainType == 2
      );

      if (orderArray.length > 0) {
        orderArray.forEach((element: any, index: any) => {
          //  this.handleRowSelectionn(e,0,prevorderid);
          this.handleRowSelectionCheck(e, index, prevorderid, "all");
        });
      } else {
        previousOrderData = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.previousOrderData))
        );
      }
      this.setState({ previousOrderData: previousOrderData });
    }
  };

  handleRowSelection = (e, rowData, Orderid) => {

    let orderData: any = [];
    let defaultPartname: any = [];
    let isStateChanged = true;
    orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    let previousOrderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.previousOrderData))
    );

    if (this != undefined) {
      let orderArray: any = [];

      orderArray = previousOrderData.filter(
        (x) => x.orderID === Orderid && x.mainType == 2
      );

      let orderlist: any = [];
      if (orderArray.length > 0) {
        orderArray.forEach((element: any, index: any) => {

          if (rowData === index) {

            let defaultPartname: any = [];
            let objPartname: any = {};
            objPartname.partname = element.partname;
            objPartname.label = element.partname;
            objPartname.id = element.productid;

            objPartname.partno = element.partNo;

            objPartname.tenantid = 0;
            objPartname.unit = element.unit;
            objPartname.unitPrice = Utils.currencyFormat(element.unitPrice);
            objPartname.noofday = null;
            objPartname.jobDesc =  element.partname;
            //element.jobDesc;

            defaultPartname.push(objPartname);
            element.defaultPartname = defaultPartname;

            element.itemNo = index + 1;
            element.dueDate = new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime));
            element.qtyOrdered = 0;

            orderData.push(element);
            let orderlistItem: any = [];
            //   dueDate:'',jobDesc:'',qtyOrdered:'',unit:'',unitPrice:'',discount:'',total:''
            orderlistItem.itemNo = index + 1;
            orderlistItem.partname = element.partname;
            orderlistItem.partno = element.partNo;
            orderlistItem.dueDate = new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime));
            //element.dueDate;
            orderlistItem.jobDesc = element.partname;
            // element.jobDesc;
            orderlistItem.qtyOrdered = 0;
            //element.qtyOrdered;
            orderlistItem.unit = element.unit;
            orderlistItem.unitPrice = Utils.currencyFormat(element.unitPrice);
            orderlistItem.discount = Utils.currencyFormat(element.discount);
            orderlistItem.total = element.total;
            orderlistItem.productid = element.productid;
            orderlist.push(orderlistItem);
          }
        });
      } else {
        orderData = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.orderData))
        );
      }

      this.setState({ orderData: orderData, defaultPartname, isStateChanged });

      this.setState({ orderData: [] }, () => {
        const orderDataNewc = orderData
          .filter((item) => item.partname !== "")
          .map((item, index) => {
            item.itemNo = index + 1;

            return item;
          });

        this.setState(
          {
            orderData: orderDataNewc,
          },
          () => { }
        );
      });
    }
  };

  handleRowSelectionn = (e, rowData, Orderid) => {

    let orderData: any = [];
    let defaultPartname: any = [];
    let isStateChanged = true;
    orderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.orderData))
    );

    let previousOrderData = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.previousOrderData))
    );

    if (this != undefined) {
      let orderArray: any = [];

      orderArray = previousOrderData.filter(
        (x) => x.orderID === Orderid && x.mainType == 2
      );

      let orderlist: any = [];
      if (orderArray.length > 0) {
        orderArray.forEach((element: any, index: any) => {

          let defaultPartname: any = [];
          let objPartname: any = {};
          objPartname.partname = element.partname;
          objPartname.label = element.partname;
          objPartname.id = element.productid;

          objPartname.partno = element.partNo;

          objPartname.tenantid = 0;
          objPartname.unit = element.unit;
          objPartname.unitPrice = Utils.currencyFormat(element.unitPrice);
          objPartname.noofday = null;
          objPartname.jobDesc =  element.partname;
          //element.jobDesc;

          defaultPartname.push(objPartname);
          element.defaultPartname = defaultPartname;

          element.itemNo = index + 1;
          element.dueDate = new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime));
          element.qtyOrdered = 0;

          orderData.push(element);
          let orderlistItem: any = [];
          //   dueDate:'',jobDesc:'',qtyOrdered:'',unit:'',unitPrice:'',discount:'',total:''
          orderlistItem.itemNo = index + 1;
          orderlistItem.partname = element.partname;
          orderlistItem.partno = element.partNo;
          orderlistItem.dueDate = new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime));
          //element.dueDate;
          orderlistItem.jobDesc =  element.partname;
          //element.jobDesc;
          orderlistItem.qtyOrdered = 0;
          //element.qtyOrdered;
          orderlistItem.unit = element.unit;
          orderlistItem.unitPrice = Utils.currencyFormat(element.unitPrice);
          orderlistItem.discount = Utils.currencyFormat(element.discount);
          orderlistItem.total = element.total;
          orderlistItem.productid = element.productid;
          orderlist.push(orderlistItem);
        });
      } else {
        orderData = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.orderData))
        );
      }

      this.setState({ orderData: orderData, defaultPartname, isStateChanged });

      this.setState({ orderData: [] }, () => {
        const orderDataNewc = orderData
          .filter((item) => item.partname !== "")
          .map((item, index) => {
            item.itemNo = index + 1;

            return item;
          });

        this.setState(
          {
            orderData: orderDataNewc,
          },
          () => { }
        );
      });
    }
  };

  handleRowSelectionAll = (e, rowIndex: any) => {
    if (this != undefined) {
      let prevorderid = this.state.prevOrderidselected;

      let orderArray: any = [];
      let previousOrderData: any = [];
      previousOrderData = Object.assign(
        [],
        JSON.parse(JSON.stringify(this.state.previousOrderData))
      );
      orderArray = previousOrderData.filter(
        (x) => x.orderID === prevorderid && x.mainType == 2
      );

      if (orderArray.length > 0) {
        orderArray.forEach((element: any, index: any) => {
          this.handleRowSelectionn(e, 0, prevorderid);
        });
      } else {
        previousOrderData = Object.assign(
          [],
          JSON.parse(JSON.stringify(this.state.previousOrderData))
        );
      }
      this.setState({ previousOrderData: previousOrderData });
    }
  };
  OpenViewer() {
    if (this.state.bulkSelect && this.state.isOpenViewer) {
      this.hideBulkselect();
    }
    this.setState(
      (prevState) => ({
        isOpenViewer: !prevState.isOpenViewer,
        singleView:false,
        fileSelect:
          this.state.savedfiles.length > 0
            ? this.state.savedfiles[0]
            : this.state.newSelectfiles[0],
        isMapped: "No",
        isExtractOption: false,
      }),
      () => {
        this.setState({ defaultView: "doc-view" });
        if (this.state.isOpenViewer) {
          setTimeout(() => {
            const innerWidthSec = this.scrollheight.current
              .getElement()
              .getBoundingClientRect().height;
            this.setState({ scrollAreaHeight: innerWidthSec });
          }, 100);
        }
      }
    );
  }

  OpenViewerSingle(index:any) {
    if (this.state.bulkSelect && this.state.isOpenViewer) {
      this.hideBulkselect();
    }
    this.setState(
      (prevState) => ({
        isOpenViewer: !prevState.isOpenViewer,
        singleView:true,
        singleViewFiles: [this.state.savedfiles[index]],
        fileSelect:
          this.state.savedfiles.length > 0
            ? this.state.savedfiles[0]
            : this.state.newSelectfiles[0],
        isMapped: "No",
        isExtractOption: false,
      }),
      () => {
        this.setState({ defaultView: "doc-view" });
        if (this.state.isOpenViewer) {
          setTimeout(() => {
            const innerWidthSec = this.scrollheight.current
              .getElement()
              .getBoundingClientRect().height;
            this.setState({ scrollAreaHeight: innerWidthSec });
          }, 100);
        }
      }
    );
  };

  rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      //this.setState({ showSlideout: true ,orderid:row.orderID
      // });
      this.handleRowSelectionCheck(e, rowIndex, row.orderID, "no");
    },
  };
  hideBulkselect() {
    this.setState({
      bulkSelect: false,
      chkIds: [],
      selectedChk: [],
      isMapped: "No",
    });
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.hideBulkSelect();
    }
  }
  setTotalPages = (totalpage) => {
    let isextractShow =
      this.state.savedfiles.length === 1 && totalpage === 1 ? true : false;
    this.setState({ isextractShow, isExtractOption: false });
  };
  handleSelectFileUpload = (eventKey: any, file, index) => {
    if (eventKey === "delete") {
      let request: any = {};
      request = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.state.formData))
      );
      let masg = "";

      masg = "Are you sure you want to delete this Attachment?";

      confirmAlert({
        title: "Delete Attachment",

        message: masg,
        buttons: [
          {
            label: "Yes",
            onClick: () => this.isDeleteattachment(file),
          },
          {
            label: "No",
            onClick: () => reject(),
          },
        ],

        closeOnEscape: false,
        closeOnClickOutside: false,
      });
    } else if (eventKey === "download") {
      this.downloadTranactionFile(file);
    }else if(eventKey === "view"){
     this.OpenViewerSingle(index);
    }
  };

  isDeleteattachment(file) {
    let newfiles: any = [];
    this.state.savedfiles.forEach((element, idx) => {
      if (Number(file.fileUniqueno) !== Number(element.fileUniqueno)) {
        newfiles.push(element);
      }
    });
    this.handleFileDelete(newfiles, file);
  }


  ShowJobModal(itemno, productid, partname, partNo, qtyOrdered, poNumber, dueDate, jobDesc, id, jobid, rNo) {

    // let requestlist = { ...this.state.requestlist };
    //this.props.GetTempateType(requestlist);
    //this.props.dropdownbind();

    this.setState({
      showjobrModal: true,
      itemNo: itemno, CustomerPoNumber: this.state.formData.CustomerPoNumber, poNumber: poNumber,
      orderid: this.state.orderid, productid: productid, partname: partname, partNo: partNo, qtyOrdered: qtyOrdered, isSpinner: false,
      selectedCustomer: this.state.formData.CustomerName + " (" + this.state.formData.customercode + ")"
      , orderdate: this.state.formData.OrderDate, dueDate: dueDate, jobDesc: jobDesc, id: id, jobid: jobid, rNo: rNo
    }, () => {

    });


  }



  isDeleteAttachment(file) {
    let newfiles: any = [];
    this.state.savedfiles.forEach((element, idx) => {
      if (Number(file.fileUniqueno) !== Number(element.fileUniqueno)) {
        newfiles.push(element);
      }
    });
    // this.handleFileAttachement(newfiles, file);
  }
  handleFileDelete(newfiles, file) {
    let request: any = {};
    request.fileUniqueno = file.fileUniqueno;
    request.orderid = this.state.orderid;

    this.handleDeleteFileFromDb(request, newfiles, 2);
  }
  handleDeleteFileFromDb(request, newfiles, id) {
    let fileno = request.fileNo;
    CustomerService.DeleteUploadedFile(request)
      .then(async (result: any | null) => {
        if (result !== null) {

          this.setState({ isSaveSpinner: false, isDisabled: false, isStateChanged: false });
          this.GetorderEntryColoumn();

        }
        resolve();
      })
      .catch((error) => {
        reject();
      });
  }
  downloadTranactionFile = (file: any) => {
    CustomerService.DownloadTranactionFile(file)
      .then(async (result: any | null) => {
        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({ isSaveSpinner: false });
      });
  };
  handleZoom = (event) => {
    let currZoom = this.state.currentZoom;
    let updateZoom;
    if (event === "zoomIn") {
      updateZoom = currZoom * 1.5;
    } else {
      updateZoom = currZoom / 1.5;
    }
    // console.log("updateZoom-" + updateZoom);
    this.setState({ currentZoom: updateZoom });
  };
  handleAllCheckbox(event) {
    for (let i = 0; i < this.state.savedfiles.length; i++) {
      this["myRef" + i].current.handleAllCheckbox(event);
    }
  }




  onFileChange = (event: any, mode) => {

    // 
    let newfiles: any = [];
    if (event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        let fileRow = event.target.files[i];
        newfiles.push(fileRow);
      }
      this.onDrop(newfiles, mode);

       if (this.fileInputRef && this.fileInputRef.current) {
      this.fileInputRef.current.value = null;
    }
    
      let fileList = document.getElementById("formControlsFile") as any;
      fileList.value = "";
    }
  };

  onDrop = (filelist: any, mode: any) => {
    let size = this.state.fileSize; //5242880//5MB
    let newfiles: any = [];
    let files: any = [];
    let isReturn = true;
    let filestext = "";
    let filesizeval = Number(Number(this.state.fileSize) / (1024 * 1024));
    filelist.forEach((element) => {
      if (element.size > size) {
        filestext = filestext + element.name + ",";
        isReturn = false;
      }
    });

    if (!isReturn) {
      let msg = "One or more files are greater than " + filesizeval + "MB.";
      toast.error(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSpinner: false});
      return false;
    }
    let isInvalidFile = false;
    filelist.forEach((element) => {
      if (
        (element.name
          .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
          .toLowerCase() === "pdf" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "doc" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "docx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "xls" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "xlsx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "csv" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "txt" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "bmp" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "tif" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "ppt" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "pptx" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "rtf" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "jpg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "jpeg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "png" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "msg" ||
          element.name
            .substring(element?.name.lastIndexOf(".") + 1, element?.name.length)
            .toLowerCase() === "eml") &&
        element.size <= size
      ) {
        newfiles.push(element);
        files.push(element);
      } else {
        isInvalidFile = true;
      }
    });
    if (isInvalidFile && isReturn) {
      let msg = "";
      if (filelist.length === 1) {
        msg = "This file type is not supported.";
      } else {
        msg = "Some files are not supported.";
      }
      toast.error(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        containerId: "OrderSlideout",
      });
      this.setState({ isSpinner: false});
      return false;
    }

    this.setState(
      {
        files,
        newSelectfiles: newfiles,
        isSave: true,
        ispopupshow: false,
        isSpinner: true,
      },
      () => {
        if (files.length > 0) {
          this.handleSaveFiles(files);
        }
      }
    );
  };

  moreActions = (eventKey: any) => {
    if (eventKey == "DuplicateOrder") {

      let orderData = this.state.orderData;
      let start: any = new Date(this.state.formData.OrderDate);
      this.state.formData.OrderDate = new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime));
      this.state.formData.shipmentNumbers = "N/A";
      this.state.formData.OrderID = 0;

      this.state.formData.OldOrderID = this.state.orderid;
      orderData.forEach(element => {
        let end: any = new Date(element.dueDate);
        let differenceInTime: any = end - start;
        element.dueDate = new Date(new Date().getTime() + differenceInTime);

      });


      this.setState({ orderData: [], orderid: 0, orderType: 'Duplicate ' }, () => {
        this.GetUploadFileList(0, 0);
        this.setState({ orderData: orderData, isStateChanged: true }, () => { });
      });
    }

    if (eventKey == "Delete") {
      //this.deleteOrder();

      if (this.state.IsDeleted == false) {

        toast.success("Order cannot be delete due to job is already created.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "OrderSlideout",
        });

      }
      else {
        let masg = "";

        masg = "Are you sure you want to delete this order?";

        confirmAlert({
          title: "Delete Order",

          message: masg,
          buttons: [
            {
              label: "Yes",
              onClick: () => this.deleteOrder(),
            },
            {
              label: "No",
              onClick: () => reject(),
            },
          ],

          closeOnEscape: false,
          closeOnClickOutside: false,
        });
      }
    }

    if (eventKey == "print") {

      this.printItem(eventKey,false);
    }
    if (eventKey == "download") {

      this.printItem(eventKey,true);
    }
    if (eventKey == "acknowledgementprint") {

      this.printItem(eventKey,false);
    }
    if (eventKey == "acknowledgementdownload") {

      this.printItem(eventKey,true);
    }
  };


  deleteOrder = () => {
    this.setState({ isSpinner: true });
    let request = { ...this.state.requestlist };
    request.orderid = this.state.orderid;
    CustomerService.DeleteOrder(request)
      .then(async (result: any | null) => {
        if (result !== null) {

          this.closeSlideOut();

          toast.success("Order has been deleted.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            containerId: "OrderSlideout",
          });



          this.setState({ isSpinner: false });

        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isdefaultColDisabled: false, isSpinner: false });
        reject();
      });
  };

  printItem = (type : any,Isdownload : any) => {
    
    var today =new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime)),
    date = today.getFullYear() +"-"+ (today.getMonth() + 1) + '-' + today.getDate();

    let saveRequest: any = {};
    saveRequest.orderid = this.state.orderid;
    saveRequest.printtype=type;

    if(type=="acknowledgementdownload")
    {

      saveRequest.name="Ackn-"+this.state.formData.CustomerPoNumber+"-"+date;
    }
    else
    {

      saveRequest.name=this.state.formData.CustomerPoNumber+"-"+date;
    }
   
    //saveRequest.tenantid = 0;
    this.setState({ isSpinner: true });

    CustomerService.DownloadCustomerPDFFile(saveRequest,Isdownload)
      .then(async (result: any | null) => {
        //this.HidecloseSlideOut();
        this.setState({ showAfterSaveModelPopup: false, isSpinner: false, });
        resolve();
      })
      .catch((error) => {
        reject();
        this.setState({ showAfterSaveModelPopup: false, isSpinner: false, });
      });
  };


  handleChangeBuyer = (event: any) => {
    let Defaultselected: any = [];
    let formData = { ...this.state.formData };
    if (event.length > 0) {


      let objData: any = {};

      objData.id = event[0].id;
      objData.name = event[0].name;
      Defaultselected.push(objData);

      formData.BuyerName = event[0].name;
    }

    this.setState({ Defaultselected: Defaultselected, formData: formData, isStateChanged: true });

  };

  showshipment = (id) => {


    this.setState({shipmentId:id, showShippingSlideout:true},()=>
    {


    }


    );
  };

  closeShippingSlideOut = () => {
    this.setState({ showShippingSlideout: false, isSpinner: false, isOpenViewer: false });

    this.GetorderEntryColoumn();
  };

  render() {
//     alert(timeZone);
// alert( formattedDate);
    const {

      showjobrModal,
      showShippingSlideout,
    } = this.state;

    const { permissions } = this.props; 
    const hasEditOrderPermission = permissions && permissions['Customer Orders'] ? permissions['Customer Orders'].includes('Edit order') : false;
    const hasAddOrderPermission = permissions && permissions['Customer Orders'] ? permissions['Customer Orders'].includes('Add Order') : false;

debugger;
   
    
    const Previouscolumns = [
      {
        searchable: this.state.iscompanypo,
        dataField: "customerPoNumber",
        text: "Customer PO #",
        sort: true,
      },
      {
        dataField: "orderDate",
        text: "Order Date",
        sort: true,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {moment(row.orderDate).format("MM/DD/YYYY")}
            </EllipsisWithTooltip>
          );
        },
      },
      {

        dataField: "totalAmount",
        text: "Order Amount",
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {Utils.currencyFormat(row.totalAmount)}
            </EllipsisWithTooltip>
          );
        },

      },
      {
        dataField: "status",
        text: "Order Status",
      },
    ];

    const expandSplitRow = {
      onlyOneExpanding: true,
      parentClassName: "parent-expand-foo",
      renderer: (row: any, rowIndex: any) => renderPreviousTableChild(row),
      showExpandColumn: true,
      expandByColumnOnly: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <div></div>;
        }
        return <div></div>;
      },
      expandColumnRenderer: ({ expanded }) => {
        if (expanded) {
          return (
            <span className="chevronExpended">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        }
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };
    const whiteBgFormatter = (column, colIndex) => {
      return <div className="white-bg"></div>;
    };

    const renderPreviousTableChild = (mainrow) => {
      let SplitPreviousDetail: any = [];
      SplitPreviousDetail = this.state.previousOrderData.filter(
        (x) => x.orderID === mainrow.orderID && x.mainType == 2 //&& (  this.state.searchPreviousData == '' || x.partNo != null && x.partNo.includes(this.state.searchPreviousData) )
      );

      // this.setState({ prevOrderidselected:  mainrow.orderID  });

      const columnChild = [
        {
          dataField: "isSelected",
          text: "",
          headerFormatter: this.icheckselectedall,
          classes: "expanding-bar",
          formatter: (cell: any, row: any, rowIndex: any) => {
            const prevOrderidselected = mainrow.orderID;
            this.setState({ prevOrderidselected: prevOrderidselected });
            return (
              <div className="d-flex align-items-center txt-bold">
                {/* <input
id={row.itemNo}
                                type="checkbox"
                                onChange={(e) => this.handleRowSelection(e, rowIndex,row.orderID)}
                                 checked={row.isChecked}
                            /> */}
                <OverlayTrigger
                  placement="bottom"
                  overlay={
                    <Tooltip id="toolp">Click to copy this part</Tooltip>
                  }
                >
                  <FontAwesomeIcon
                    icon={faArrowUp}
                    size="xs"
                    onClick={(e) =>
                      this.handleRowSelectionCheck(
                        e,
                        rowIndex,
                        row.orderID,
                        "no"
                      )
                    }
                  />
                </OverlayTrigger>
              </div>
            );
          },
        },
        {
          dataField: "partname",
          text: "Part Description",
          headerStyle: { width: "33%" },
          classes:"expanding-bar text-truncate",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
             
              <div className="d-flex align-items-center txt-bold">
                 <div style={{width: '350px'}}>
                <EllipsisWithTooltip placement="bottom">
                  {row.partname}
                </EllipsisWithTooltip>
              </div>
              </div>
            );
          },
        },
        {
          dataField: "partNo",
          text: "Part No",
          classes: "expanding-bar",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {row.partNo}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "dueDate",
          text: "Due Date",
          classes: "expanding-bar",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {moment(row.dueDate).format("MM/DD/YYYY")}
              </EllipsisWithTooltip>
            );
          },
        },
        // {
        //   dataField: "jobDesc",
        //   text: "Description",
        //   classes: "expanding-bar",
        //   formatter: (cell: any, row: any, rowIndex: any) => {
        //     return (
        //       <EllipsisWithTooltip placement="bottom">
        //         {row.jobDesc}
        //       </EllipsisWithTooltip>
        //     );
        //   },
        // },
        {
          dataField: "unit",
          text: "Unit",
          hidden: true,
          classes: "expanding-bar",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {Utils.amountFormatted(row.unit)}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: "qtyOrdered",
          text: "Qty Ordered",
          headerClasses: "text-end pe-4",
          classes: "text-end pe-4 expanding-bar",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <div>
                {Utils.amountFormatted(Number(row.qtyOrdered).toFixed(2))}
              </div>
            );
          },
        },

        {
          dataField: "unitPrice",
          text: "Unit Price",
          headerClasses: "text-end pe-4",
          classes: "text-end pe-4 expanding-bar",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <div>
                {Utils.currencyFormat(Number(row.unitPrice).toFixed(2))}
              </div>
            );
          },
        },

        {
          dataField: "discount",
          text: "Discount",
          headerClasses: "text-end pe-4",
          classes: "text-end pe-4 expanding-bar",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <div>
                {Utils.currencyFormat(Number(row.discount).toFixed(2))}
              </div>
            );
          },
        },
        {
          dataField: "total",
          text: "Total",
          headerClasses: "text-end pe-4 ",
          classes: "text-end pe-4 expanding-bar",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <div>
                {Utils.currencyFormat(
                  Number(row.qtyOrdered * row.unitPrice - row.discount).toFixed(2)
                )}
              </div>
            );
          },
        },
        {
          dataField: "",
          text: "",
          headerClasses: "blankLastChildofChild",
          classes: "expanding-bar",
        },
        {
          dataField: "",
          text: "",
          headerClasses: "cl",
          classes: "expanding-bar",
          headerFormatter: whiteBgFormatter,

        },
      ];

      return (
        <>
          <div className='px-4 p-4' id='divprevious'>
            <BootstrapTable
              id="tblCOAchild"
              keyField="uniqueNo"
              data={SplitPreviousDetail}
              columns={columnChild}
              rowEvents={this.rowEvents}
            // selectRow={ selectRow }
            //  onClick={(e) => this.handleRowSelectionCheck(e, rowIndex,row.orderID,"no")}
            />
          </div>
        </>

      );
    };
    // console.log(this.state.formData.customercode);


    const files = this.state.newSelectfiles.map((file, index) => (
      <>
        <div>
          <li key={file.name}>
            <div className="d-flex align-items-center justify-content-start">
              <div className="file-info d-flex align-items-center">
                <div className="name-loader d-flex align-items-center">
                  <div className="name">
                    <EllipsisWithTooltip placement="bottom">
                      <div
                        className="full-name"
                        style={{ fontSize: '14px', marginRight: '70px' }}
                        onClick={() => {
                          this.handlePreview(file);
                        }}
                      >
                        {file.name}
                      </div>
                    </EllipsisWithTooltip>
                  </div>
                </div>
                <div className="formate-percentage">
                  <div className="formate d-flex justify-content-center align-items-center">
                    {file?.name.substring(
                      file?.name.lastIndexOf(".") + 1,
                      file?.name.length
                    )}
                  </div>
                </div>
              </div>
            </div>
          </li>
        </div>
      </>
    ));

    const files1 = this.state.savedfiles.map((file, index) => (
      <>
        <div>
          <li key={file.name}>
            <div className="d-flex align-items-center justify-content-start">

              <div className="file-info d-flex align-items-center">
                <div className="name-loader d-flex align-items-center">
                  <div className="name">
                    <EllipsisWithTooltip placement="bottom">
                      <div className="full-name" style={{ fontSize: '14px', marginRight: '70px' }}>{file.name}</div>
                    </EllipsisWithTooltip>
                  </div>
                </div>
              </div>
              <div className="action">
                {
                  <Dropdown
                    className="more-action"
                    
                    onSelect={(event: any) =>
                      this.handleSelectFileUpload(event, file, index)
                    }
                  >
                    <Dropdown.Toggle
                      className="btn-outline-primary btn btn-primary more border-0"
                      id="dropdown-more"
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                        <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                        <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {this.state.moreActionFileUpload1.map(
                        (item: any, idx: any) => (
                          <>
                            {this.state.orderid === 0 && (
                              <Dropdown.Item
                              className={(  this.state.moreActionFileUpload1[idx].eventKey === "delete" && !hasEditOrderPermission) ? "isHide" : ""}                                //className={((this.state.formData.actionType === "copy" || this.state.isError === "NotEdit") && this.state.formData.uniqueno > 0) ? "isHide" : ""}
                                eventKey={
                                  this.state.moreActionFileUpload1[idx].eventKey
                                }
                                key={idx}
                              >
                                {this.state.moreActionFileUpload1[idx].name}
                              </Dropdown.Item>
                            )}

                            {this.state.orderid > 0 && (
                              <Dropdown.Item
                                className={(  this.state.moreActionFileUpload1[idx].eventKey === "delete" && !hasEditOrderPermission) ? "isHide" : ""}                                eventKey={
                                  this.state.moreActionFileUpload1[idx].eventKey
                                }
                                key={idx}
                              >
                                {this.state.moreActionFileUpload1[idx].name}
                              </Dropdown.Item>
                            )}
                          </>
                        )
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                }
              </div>
            </div>
          </li>
        </div>
      </>
    ));
    const savedfilesCount = this.state.savedfiles.length;
    const allsavedfiles = this.state.savedfiles;
    const currentView = this.state.defaultView;

    const handleUpdate = (newtext) => {
      //this.setState({ defaultView: "doc-view"});
      toggleSwitch("doc-view");
      setTimeout(function () {
        var currentPos: any = $(`#${newtext}`).offset()?.top;
        var marginArea = currentPos - 138;
        $(".scroll-area").animate(
          {
            scrollTop: marginArea,
          },
          500
        );
      }, 500);
    };

    const handleUpdateFiles = (docFiles) => {
      //let docViewerFiles : any =[];
      docViewerFiles.push(docFiles);
      //this.setState({ docViewerFiles: docFiles })
    };

    const showBulkSelect = (type) => {
      this.setState({ bulkSelect: type === "show" ? true : false });
      for (let i = 0; i < this.state.savedfiles.length; i++) {
        this["myRef" + i].current.showBulkSelect();
      }
    };

    const checkBulkSelect = (type, totalpage) => {
      // selectedPage =totalpage;
      if (totalpage === 0) {
        this.footerchk.current.labels[0].innerHTML = "No Page Selected";
      } else if (totalpage === 1) {
        this.footerchk.current.labels[0].innerHTML =
          totalpage + " Page Selected";
      } else {
        this.footerchk.current.labels[0].innerHTML =
          totalpage + " Pages Selected";
      }
      if (type === "removeAll") {
        this.footerchk.current.indeterminate = false;
        this.footerchk.current.checked = false;
      } else {
        if (type === "helf") {
          this.footerchk.current.indeterminate = true;
        } else {
          this.footerchk.current.indeterminate = false;
          this.footerchk.current.checked = true;
        }
      }
    };
    const toggleSwitch = (event: any) => {
      this.setState({ defaultView: event });
      $(".scroll-area").animate(
        {
          scrollTop: 0,
        },
        500
      );
    };


    return (

      <section>
        <div className="details-drawer"
          style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
        // className="back-drop1  viewer-panel1 opacity "
        >
          <ToastContainer
            containerId={"userDetailSlideoutcontainer"}
            autoClose={3000}
          />
          {!this.state.isOpenViewer && (
            <div
              className="back-drop1  viewer-panel1 opacity"
              onClick={() => this.closeSlideOut()}
            ></div>
          )}
          {this.state.isOpenViewer && (
            <div
              className="back-drop viewer-panel bg-white z-3 position-absolute"
              //className="body-sec viewer-panel back-drop p-0 z-3"
              style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}

            >
              <div
                className="scroll"
              >
                <div className="header-panel d-flex justify-content-between align-items-center">
                  <div className="page-ttl">Attachments</div>
                  {/* <div className="toggle-button">
                    <ButtonGroup aria-label="Basic example">
                      <ToggleButtonGroup
                        type="radio"
                        name="options"
                        value={this.state.defaultView}
                        onChange={toggleSwitch}
                      >
                        <ToggleButton value={"doc-view"} id={"t1"}>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M10.155 12.1267C9.64082 12.1267 9.34082 12.6159 9.34082 13.2709C9.34082 13.93 9.64999 14.3959 10.16 14.3959C10.6742 14.3959 10.9692 13.9059 10.9692 13.2509C10.9692 12.6459 10.6792 12.1267 10.155 12.1267Z" />
                            <path d="M11.6666 1.66663H4.99992C4.55789 1.66663 4.13397 1.84222 3.82141 2.15478C3.50885 2.46734 3.33325 2.89127 3.33325 3.33329V16.6666C3.33325 17.1087 3.50885 17.5326 3.82141 17.8451C4.13397 18.1577 4.55789 18.3333 4.99992 18.3333H14.9999C15.4419 18.3333 15.8659 18.1577 16.1784 17.8451C16.491 17.5326 16.6666 17.1087 16.6666 16.6666V6.66663L11.6666 1.66663ZM11.6666 7.49996H10.8333V3.33329L14.9999 7.49996H11.6666Z" />
                          </svg>
                        </ToggleButton>
                        <ToggleButton value={"grid-view"} id={""}>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M3.33333 9.16667H8.33333C8.55435 9.16667 8.76631 9.07887 8.92259 8.92259C9.07887 8.76631 9.16667 8.55435 9.16667 8.33333V3.33333C9.16667 3.11232 9.07887 2.90036 8.92259 2.74408C8.76631 2.5878 8.55435 2.5 8.33333 2.5H3.33333C3.11232 2.5 2.90036 2.5878 2.74408 2.74408C2.5878 2.90036 2.5 3.11232 2.5 3.33333V8.33333C2.5 8.55435 2.5878 8.76631 2.74408 8.92259C2.90036 9.07887 3.11232 9.16667 3.33333 9.16667ZM11.6667 9.16667H16.6667C16.8877 9.16667 17.0996 9.07887 17.2559 8.92259C17.4122 8.76631 17.5 8.55435 17.5 8.33333V3.33333C17.5 3.11232 17.4122 2.90036 17.2559 2.74408C17.0996 2.5878 16.8877 2.5 16.6667 2.5H11.6667C11.4457 2.5 11.2337 2.5878 11.0774 2.74408C10.9211 2.90036 10.8333 3.11232 10.8333 3.33333V8.33333C10.8333 8.55435 10.9211 8.76631 11.0774 8.92259C11.2337 9.07887 11.4457 9.16667 11.6667 9.16667ZM3.33333 17.5H8.33333C8.55435 17.5 8.76631 17.4122 8.92259 17.2559C9.07887 17.0996 9.16667 16.8877 9.16667 16.6667V11.6667C9.16667 11.4457 9.07887 11.2337 8.92259 11.0774C8.76631 10.9211 8.55435 10.8333 8.33333 10.8333H3.33333C3.11232 10.8333 2.90036 10.9211 2.74408 11.0774C2.5878 11.2337 2.5 11.4457 2.5 11.6667V16.6667C2.5 16.8877 2.5878 17.0996 2.74408 17.2559C2.90036 17.4122 3.11232 17.5 3.33333 17.5ZM11.6667 17.5H16.6667C16.8877 17.5 17.0996 17.4122 17.2559 17.2559C17.4122 17.0996 17.5 16.8877 17.5 16.6667V11.6667C17.5 11.4457 17.4122 11.2337 17.2559 11.0774C17.0996 10.9211 16.8877 10.8333 16.6667 10.8333H11.6667C11.4457 10.8333 11.2337 10.9211 11.0774 11.0774C10.9211 11.2337 10.8333 11.4457 10.8333 11.6667V16.6667C10.8333 16.8877 10.9211 17.0996 11.0774 17.2559C11.2337 17.4122 11.4457 17.5 11.6667 17.5Z" />
                          </svg>
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </ButtonGroup>
                  </div> */}
                  <div className="action d-flex">
                    <button
                      type="button"
                      className="btn wht-bg cross"
                      style={{backgroundColor:'#164DA0'}}
                      onClick={this.OpenViewer}
                    >
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                          fill="white"
                        />
                      </svg>
                    </button>
                  </div>
                </div>

                <ScrollContainer
                  className="doc-view scroll-area1"
                  // className={`scroll-area ${this.state.modalOpen === "yes" ? "modal-open" : ""
                  //   } ${currentView !== "doc-view" ? "grid-sec" : "doc-sec"}`}


                  ref={this.scrollheight}
                  hideScrollbars={false}
                >
                  <>
                    {/* {this.state.savedfiles.map((file: any, i: any) => { */}
                    {(this.state.singleView ? this.state.singleViewFiles : this.state.savedfiles).map((file: any, i: any) => {
                      return (
                        <div
                          id={`sec_${file.id}`}
                          className={this.state.bulkSelect ? "footer-enable" : ""}
                        >
                          <div
                            className={
                              currentView !== "doc-view" ? "grid-sec" : "doc-sec"
                            }
                          >
                            <PDFViewer
                              //ref={childViewerref}
                              ref={this["myRef" + i]}
                              scrollAreaHeight={this.state.scrollAreaHeight}
                              isModalOpen={this["isModalOpen"]}
                              uniqueno={this.state.orderID}
                              filePreview={file.fileCode}
                              defaultView={currentView}
                              fileNo={file.fileUniqueno}
                              fileCount={savedfilesCount}
                              fileName={file.name}
                              // docFile={docViewerFiles}
                              docFile={allsavedfiles}
                              updateState={handleUpdate}
                              updateFiles={handleUpdateFiles}
                              showBulkSelect={showBulkSelect}
                              checkBulkSelect={checkBulkSelect}
                              handleFileCheckBox={this["handleFileCheckBox"]}
                              handleUpdatedFile={this["handleUpdatedFile"]}
                              handleincompleteFile={this["handleincompleteFile"]}
                              saveSplitFile={this["saveSplitFile"]}
                              pageType={this.props.pageType}
                              handleRotate={this["handleRotate"]}
                              handlePageRemove={this["handlePageRemove"]}
                              selectedChk={this.state.selectedChk}
                              selectedZoom={this.state.currentZoom}
                              setTotalPages={this["setTotalPages"]}
                              isEditPermission={true}
                            />
                          </div>
                        </div>
                      );
                    })}

                    {currentView === "doc-view" && (
                      <div className="zoom-btn">
                        <ButtonGroup vertical>
                          <Button
                            onClick={(e) => this.handleZoom("zoomIn")}
                            disabled={
                              this.state.currentZoom >= 3.375 ? true : false
                            }
                          >
                            <FontAwesomeIcon icon={faPlus} />
                          </Button>
                          <Button
                            onClick={(e) => this.handleZoom("zoomOut")}
                            disabled={
                              this.state.currentZoom <= 0.44 ? true : false
                            }
                          >
                            <FontAwesomeIcon icon={faMinus} />
                          </Button>
                        </ButtonGroup>
                      </div>
                    )}
                    {this.state.bulkSelect && (
                      <div className="footer-section d-flex align-items-center">
                        <Form.Check
                          
                          type="checkbox"
                          key={"custom-footer"}
                          id={"custom-footer"}
                          label={"No Page Selected"}
                          onChange={(e: any) => this.handleAllCheckbox(e)}
                          ref={this.footerchk}
                        />
                      </div>
                    )}
                  </>
                </ScrollContainer>
              </div>
            </div>
          )}

          <Container
            fluid

            className="body-sec viewer-panel back-drop p-0"
            style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}

          >


            <div
              className="container-fluid py-1 bg-white d-flex align-items-center  border-bottom round-4"  >
              <div className="divheader">
                <h5 className="my-title">
                  {this.state.orderid == 0 && <span>New {this.state.orderType}Order</span>}
                  {this.state.orderid != 0 && (
                    <span>Order No : {this.state.formData.CustomerPoNumber}</span>



                  )}


{/* {this.state.formData.shipmentNumbers=='N/A'  && ( <span></span>) }
{this.state.formData.shipmentNumbers!='N/A' &&(
<span className="badge badge-pill badge-primary color-green">Shipment No : {this.state.formData.shipmentNumbers}</span>
  )}
   */}

{this.state.formData.shipmentNumbers !== 'N/A' ? (
  <span className="badge badge-pill badge-primary color-green">
    Shipment No:{" "}
    {this.state.formData.shipmentNumbers.match(/ID: (\d+), No: (\d+)/g)?.map((shipment, index, array) => {
      // Extract Shipment ID and Number using regex
      const match = shipment.match(/ID: (\d+), No: (\d+)/);
      if (!match) return null; // Skip if format is incorrect

      const shipmentId = match[1]; // Extracted Shipment ID
      const shipmentNo = match[2]; // Extracted Shipment Number

      return (
        <div className="d-inline-block">
      
          <a
          onClick={() => this.showshipment(shipmentId)} className="orderLinks"
          
          >
            {shipmentNo}
          </a>
          {index < array.length - 1 && ", "} {/* Add comma except for last item */}
      
        </div>
      );
    })}
  </span>
) : (
  <span></span>
)}


                </h5>
                <div className="header-popout ml-auto">


                  <div className="container text-center">
                    <div className="row align-items-start">
                      <div className="col">
                      </div>
                      <div className="col">
                        {this.state.jobid != 0
                          //  && this.state.jobTrackerId === 0 
                          //                             && !this.state.processVendorPOCreated && !this.state.materialVendorPOCreated
                          &&

                          <div className="action">



                            <Dropdown
                              className="more-action"
                              
                              onSelect={(event: any) => { this.moreActions(event); }}
                            >
                              <Dropdown.Toggle
                                className="btn-outline-primary btn btn-primary more"
                                id="dropdown-more"
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 20 20"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                                  <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                                  <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                                </svg>
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {this.state.orderid != 0 && (
                                  <>
                                   <Dropdown.Item
                                      eventKey={"acknowledgementprint"}
                                      key={1}
                                    >
                                      {"Acknowledgement Print"}
                                    </Dropdown.Item>

                                   

                                    <Dropdown.Item
                                      eventKey={"print"}
                                      key={1}
                                    >
                                      {"Order Print"}
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      eventKey={"acknowledgementdownload"}
                                      key={1}
                                    >
                                      {"Acknowledgement Download"}
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      eventKey={"download"}
                                      key={1}
                                    >
                                      {"Order Download"}
                                    </Dropdown.Item>

                                    <Dropdown.Item
                                      eventKey={"DuplicateOrder"}
                                      key={1}
                                    >
                                      {"Duplicate Order"}
                                    </Dropdown.Item>
                                    {this.state.IsDeleted == true && (
                                      <Dropdown.Item
                                        eventKey={"Delete"}
                                        key={1}
                                      >
                                        {"Delete"}
                                      </Dropdown.Item>
                                    )}

                                  </>
                                )}

                              </Dropdown.Menu>
                            </Dropdown>



                          </div>


                        }
                      </div>
                      <div className="col">
                        <button
                          type="button"
                          className="btn btn-primary cross"
                          onClick={this.closeSlideOut}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M16.192 6.34399L11.949 10.586L7.70697 6.34399L6.29297 7.75799L10.535 12L6.29297 16.242L7.70697 17.656L11.949 13.414L16.192 17.656L17.606 16.242L13.364 12L17.606 7.75799L16.192 6.34399Z"
                              fill="#ffffff"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>


                </div>
              </div>

            </div>
            <div
              className="scroll"
            >
              <section className="pb-3">
    <div className="row g-3">

      <div className="col-12 col-md-4" >
        <div className="card h-100">
          <div className="card-header">
            Customer Details
          </div>
          <div className="card-body">
            <div className="row g-3">
              <div className="col-md-12" >
                <Form.Group controlId="customerName">
                  <div className="parent my-data">
                    <Form.Label className="font-semibold">
                      Customer Name
                    </Form.Label>
                    <div
                      tabIndex={this.state.tabEnable}
                      className="type-head w-full"
                    >
                      <CustomerSearch
                        ref={this.customerSearch}
                        updateCustomerList={this.updateCustomerList}
                        handleCustomerChange={
                          this.handleCustomerChange
                        }
                      />
                      <div className="d-inline-block">
                        {this.state.formData.CustomerID > 0 && this.state.previousOrderData.length > 0 &&
                          <a onClick={() => this.showprevious()} className="orderLinks" >{this.state.isprevious == false ? "Show Previous orders" : "Hide Previous orders"}   </a>
                        }
                      </div>
                    </div>
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-12" >
                <Form.Group controlId="buyerName">
                  <div className="parent my-data">
                    <Form.Label className="font-semibold">
                      Contact Name
                    </Form.Label>
                    <div
                      tabIndex={this.state.tabEnable}
                      className="type-head"
                    >
                      {/* <Form.Control
  tabIndex={this.state.tabEnable}
  id="txtBuyerName"
  type="text"
  placeholder="Enter Buyer Name."
  value={this.state.formData.BuyerName}
  onChange={(event: any) => this.handleChange(event, 'BuyerName')} 
  autoComplete="off"

  disabled={false}
  title=""
/> */}

                      <Typeahead

                        id="selections-example"
                        labelKey="name"
                        onInputChange={(text: string, e: ChangeEvent<HTMLInputElement>) => {
                          // console.log(text, e);
                          this.state.formData.BuyerName = text;
                        }}
                        onChange={(e) => this.handleChangeBuyer(e)}
                        // className="w-80"
                        options={this.state.options}
                        placeholder="Select contact details..."
                        selected={this.state.Defaultselected}
                      />
                    </div>
                  </div>
                </Form.Group>

              </div>
              
            </div>
          </div>
        </div>

      </div>
      <div className="col-12 col-md-4"   >
        <div className="card h-100">
          <div className="card-header">
            Order Details
          </div>
          <div className="card-body">
            <div className="row g-3">
              <div className="col-md-12" >
                <div className="row g-3">
                <div className="col-md-6" >
                <Form.Group controlId="vendorName">
                  <div className="parent my-data">
                    <Form.Label className="font-semibold">
                      Order Date
                    </Form.Label>
                    <div className="date-picker calender-picker">

                      <DatePicker
                        ref={this.trDate}
                        id="txtOrderDate"
                        tabIndex={this.state.tabEnable}
                        className="form-control px-0 w-full text-start px-2"
                        placeholderText={"MM/DD/YY"}
                        dateFormat="MM/dd/yy"
                        // selected={
                        //   this.state.formData.OrderDate === null
                        //     ? new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime))
                        //     : this.state.formData.OrderDate === ""
                        //       ? new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime))
                        //       : new Date(this.state.formData.OrderDate)
                        // }
                          selected={
                          this.state.formData.OrderDate === null
                            ? null
                            : this.state.formData.OrderDate === ""
                              ? null
                              : new Date(this.state.formData.OrderDate)
                        }
                        onChange={(event: any) =>
                          this.handleChange(event, "orderDate")
                        }
                        // onKeyDown={(e: any) =>
                        //   this.onTAB("txtOrderDate-1", 0, e)
                        // }
                        onClick={(e: any) =>
                          this.onTAB("txtOrderDate-1", 0, e)
                        }
                        autoComplete="off"
                      // disabled={isBedgeProcessing && true}
                      />
                    </div>
                  </div>
                </Form.Group>
              </div>
              <div className="col-md-6" >
                    <Form.Group controlId="quotationNo">
                      <div className="parent my-data">
                        <Form.Label className="font-semibold">
                          Quotation No.
                        </Form.Label>
                        <div
                          tabIndex={this.state.tabEnable}
                          className="type-head"
                        >
                          <Form.Control
                            tabIndex={this.state.tabEnable}
                            id="txtQuotationNo"
                            type="text"
                            placeholder="Enter Q No."
                            value={this.state.formData.QuotationNo}
                            onChange={(event: any) => this.handleChange(event, 'QuotationNo')}
                            autoComplete="off"
                            className="w-full"
                            disabled={this.state.formData.CustomerID > 0 ? true : false}
                            title=""
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6" style={{paddingTop:"7%"}}>
                    <Form.Group controlId="externalCustomerPO">
                      <div className="parent my-data">
                        <Form.Label className="font-semibold">
                          Customer PO No
                        </Form.Label>
                        <div
                          tabIndex={this.state.tabEnable}
                          className="type-head"
                        >
                          <Form.Control
                            tabIndex={this.state.tabEnable}
                            id="txtExternalCustomerPO"
                            type="text"
                            placeholder="Enter PO No."
                            value={this.state.formData.ExternalCustomerPO}
                            onChange={(event: any) => this.handleChange(event, 'ExternalCustomerPO')}
                            autoComplete="off"

                            disabled={false}
                            title=""
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-6" style={{paddingTop:"7%"}}>
                    <Form.Group controlId="vendorName">
                      <div className="parent my-data">
                        <Form.Label className="font-semibold">
                          Cust. Order Date
                        </Form.Label>
                        <div className="date-picker calender-picker">


                          <DatePicker
                            ref={this.trpoDate}
                            id="txtExternalOrderDate"
                            tabIndex={this.state.tabEnable}
                            className="form-control px-0 w-full text-start px-2"
                            placeholderText={"MM/DD/YY"}
                            dateFormat="MM/dd/yy"
                            selected={
                              this.state.formData.ExternalOrderDate === null
                                ? new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime))
                                : this.state.formData.ExternalOrderDate === ""
                                  ? new Date( Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime))
                                  : new Date(this.state.formData.ExternalOrderDate)
                            }
                            onChange={(event: any) =>
                              this.handleChange(event, "ExternalOrderDate")
                            }
                            // onKeyDown={(e: any) =>
                            //   this.onTAB("txtOrderDate-1", 0, e)
                            // }
                            onClick={(e: any) =>
                              this.onTAB("txtExternalOrderDate-1", 0, e)
                            }
                            autoComplete="off"
                          // disabled={isBedgeProcessing && true}
                          />
                        </div>
                      </div>
                    </Form.Group>
                  </div>

                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-4"   >
        <div className="card h-100">
          <div className="card-header">
            Shipping Details
          </div>
          <div className="card-body d-flex flex-column" style={{ padding: '1rem' }}>
            <Form.Group controlId="exampleForm.ControlTextarea1" className="flex-grow-1">
              <Form.Label className="font-semibold">
                Address
              </Form.Label>
              <Form.Control
                id="txtaddress"
                as="textarea"
                className="txtarea"
                //wrap=""
                rows={4}
                value={this.state.formData.Address}
                disabled={true}
                maxLength={99}
                style={{ resize: "none", height: '82%', flexGrow: 1 }}
                />
            </Form.Group>
          </div>
        </div>

      </div>

    </div>
  </section>

              <div className="table-responsive table-responsive1" >
                <section className="pb-3">
                  <div
                  //className="transactions-list"

                  >
                    <div
                      id="order"
                    //className="table-responsive"
                    //className={this.state.responsive} 
                    //style={{minHeight:"170px"}}
                    >
                      {this.state.transactionsColumns.length > 0 && (
                        <div
                          className="table table-borderless align-middle transactions-list"

                        >

                          <BootstrapTable
                            id="tblOrder"
                            keyField="orderID"
                            data={this.state.orderData}
                            columns={this.state.transactionsColumns}
                          // rowEvents={this.rowEvents1}
                          />

                        </div>
                      )}
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                      <div className="d-flex action-btn align-items-center">
                        <Button
                          type="button"
                          className="btn-ghost mr-auto"
                          onClick={this.handleNewRow}
                        >
                          <FaCirclePlus className="align-middle lh-1`" /> <span className="align-middle lh-1">Add Row</span>
                        </Button>




                      </div>
                    </div>
                  </div>
                </section>
                <hr></hr>
                <div >

                  {this.state.isprevious && (
                    <div className="row g-3">
                      <div className="col-12 col-md-12">

                        <div className="transactions-list inpute">
                          {this.state.isprevious && (
                            <div className="PreviousTransactions">

                              <div className="d-flex">
                                <section className="mt-3">
                                  <div className="my-data">Add from Previous Orders</div>
                                </section>

                                <section className="d-flex flex-wrap">
                                  <div className="search-header w-auto px-2 pb-2">
                                    <Form.Control
                                      tabIndex={this.state.tabEnable}
                                      id="search"
                                      type="text"
                                      placeholder="Search PO # or Part No"
                                      // value={row.glcode}
                                      onChange={(e) => this.handleChange(e, "SearchPreviousData")}
                                      //onBlur={this.loadPreviousData}
                                      // autoComplete="off"
                                      // disabled={disable}
                                      title=""
                                    />


                                  </div>

                                  <div
                                  //className="input-group w-auto"
                                  >

                                  </div>

                                </section>
                              </div>

                              {this.state.displayRecordCount > 0 && <BootstrapTable
                                keyField="orderID"
                                data={this.state.previousOrderData.filter(
                                  (x) => x.mainType == 1 && ((this.state.searchPreviousData == '' || (x.customerPoNumber != null && x.customerPoNumber.toLowerCase().includes(this.state.searchPreviousData.toLowerCase()))
                                    || this.state.previousOrderData.filter((a) =>
                                    a.partNo != null && a.partNo.toLowerCase().includes(this.state.searchPreviousData.toLowerCase())  
                                      && x.customerPoNumber.toLowerCase() == a.customerPoNumber.toLowerCase()).length > 0))
                                ).slice(0, this.state.displayRecordCount)}
                                columns={Previouscolumns}
                                expandRow={expandSplitRow}
                              />}
                              {Number(this.state.displayRecordCount) <= this.state.previousOrderData.filter(
                                (x) => x.mainType == 1 && ((this.state.searchPreviousData == '' || (x.customerPoNumber != null && x.customerPoNumber.toLowerCase().includes(this.state.searchPreviousData.toLowerCase()))
                                  || this.state.previousOrderData.filter((a) =>
                                  a.partNo != null && a.partNo.toLowerCase().includes(this.state.searchPreviousData.toLowerCase())  
                                    && x.customerPoNumber.toLowerCase() == a.customerPoNumber.toLowerCase()).length > 0))
                              ).length &&
                                <button
                                  type="button"
                                  className="btn wht-bg link-btn"
                                  onClick={this.showMore}
                                >
                                  Show More
                                </button>}
                            </div>
                          )}
                        </div>
                        <hr className="hr hr-blurry" />
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <div className="col-12 col-md-6">

                 
                          <div
                            className="filter-sec upload-section"
                          >

                            <Form.Group  className="w-100">

                              <div>
                                <Form.Label>
                                  {
                                    <div className="upload-link mrgn-top">
                                      <button
                                        type="button"
                                        className="btn wht-bg link-btn mr-auto"
                                      >
                                        Add Attachment
                                      </button>
                                      <Form.Control
                                        id="formControlsFile"
                                        type="file"
                                        className="form-control-file"
                                        multiple
                                        onChange={(event: any) =>
                                          this.onFileChange(event, "1")
                                        }
                                        accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                      />
                                    </div>
                                  }
                                </Form.Label>

                                {this.state.savedfiles.length > 0 && (
                                  <Form.Label className="mr-auto">
                                    <div className="upload-link mrgn-top">
                                      <button
                                        type="button"
                                        className="btn wht-bg link-btn mr-auto"
                                        onClick={this.OpenViewer}
                                      // data-bs-toggle="modal" data-bs-target="#exampleModal"
                                      >
                                        {this.state.isOpenViewer
                                          ? "Close Viewer"
                                          : "Open Viewer"}
                                      </button>
                                    </div>
                                  </Form.Label>
                                )}
                            
                             
                              <div className="mt-1 py-3 rounded-3 text-center text-secondary"
                                style={{ border: "solid 1px #c0c0c0" }}>
                                <Dropzone
                                  // disabled={isBedgeProcessing}
                                  onDrop={this.onDrop}
                                // accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                >
                                  {({
                                    getRootProps,
                                    getInputProps,
                                    isDragActive,
                                    isDragReject,
                                  }) => (
                                    <>
                                      <aside>
                                        {/* <ul>{files}</ul> */}
                                        <ul>{files1}</ul>
                                         <ul style={{textAlign:'left'}}> 
                                                                                                                                     {this.state.savedfiles.length> 0 && (
                                                                                           
                                                                                                                                     <Form.Label>
                                                                                                                                     {
                                                                                                                                       <div className="upload-link mrgn-top">
                                                                                                                                         <button
                                                                                                                                           type="button"
                                                                                                                                           className="btn"
                                                                                                                                           style={{fontSize:'14px'}}
                                                                                                                                           onClick={this.handleButtonClick}
                                                                                                                                         >
                                                                                                                                           <FaCirclePlus style={{color:'#164DA0'}} className="align-middle lh-1`" />{" "}
                                                                                                                                           <span style={{color:'#164DA0'}}>Add Attachment</span>
                                                                                                                                         </button>
                                                                                                                                         <Form.Control
                                                                                                                                           ref={this.fileInputRef}
                                                                                                                                           id="formControlsFile"
                                                                                                                                           type="file"
                                                                                                                                           className="form-control-file"
                                                                                                                                           multiple
                                                                                                                                           onChange={(event: any) =>
                                                                                                                                             this.onFileChange(event, "1")
                                                                                                                                           }
                                                                                                                                           accept="image/*,application/pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.bmp,.tif,.ppt,.pptx,.rtf,.jpg,.png,.msg,.eml"
                                                                                                                                         />
                                                                                                                                       </div>
                                                                                                                                     }
                                                                                                                                     </Form.Label>
                                                                                           
                                         )}</ul>
                                      </aside>
                                      <section className="container upload-area default">
                                        {/* {!this.state.bulkSelect && ( */}
                                        {this.state.savedfiles.length < 1 && (
                                          <div
                                            {...getRootProps({
                                              className:
                                                "dropzone align-items-center",
                                               onClick:(event) => event,
                                                // this.state.newSelectfiles.length > 0 ||
                                                //   this.state.savedfiles.length > 0
                                                //   ? (event) => event.stopPropagation()
                                                //   : (event) => event,
                                            })}
                                          >
                                            <input {...getInputProps()} />
                                            {/* {this.state.newSelectfiles.length < 1 && */}
                                              {this.state.savedfiles.length < 1 && (
                                                <p>
                                                  Drag and drop attachment or{" "}
                                                  <span>browse files</span> to upload.
                                                </p>
                                              )}
                                            {(this.state.newSelectfiles.length > 0 ||
                                              this.state.savedfiles.length > 0)
                                              &&
                                              isDragActive && (
                                                <p>
                                                  Drag and drop attachment here to upload.
                                                </p>
                                              )}
                                            {/* {!isDragActive && (<p>Drag and drop or <span>browse files</span> to upload</p>)} */}
                                          </div>
                                          // </div>
                                        )}
                                        {/* {this.state.bulkSelect && (
                                                                        <div className="dropzone d-flex align-items-center">
                                                                            <p>Drag and drop or <span>browse files</span> to upload</p>
                                                                        </div>
                                                                    )} */}
                                        {

                                        }
                                        {/* <aside>

                                          <ul >{files}</ul>
                                          <ul >{files1}</ul>

                                        </aside> */}

                                      </section>


                                    </>
                                  )}

                                </Dropzone>

                              </div>
                              </div>
                            </Form.Group>
                          </div>
                       
                    </div>


                    <div className="col-12 col-md-6">
                      {(this.state.orderid != 0 &&
                        <CommentBox
                          ref={this.ChildComment}
                          hotelid={this.state.hotelValue}
                          entryType={"CustomerOrder"}
                          //={this.state.formData.actionType === "copy" ? 0 : this.props.pageType === "Invoice" ? this.state.formData.uniqueno : this.state.formData.incompleteUniqueno}
                          uniqueNo={this.state.orderid}
                          precommentlist={this.state.htmlcomment}
                          parentScrollMethod={this.scrollToBottom}
                          updatedCommentItem={this.updatedCommentItem}
                          commentModalClose={this.CommentModalClose}

                        />
                      )}
                    </div>
                  </div>


                </div>
              </div>
              <div className="filter-sec height-172">

                <br></br>
                <br></br>

              </div>
            


              <div className={"footer-section viewer-panel"}
                style={{ minWidth: "75%", width: "992px", maxWidth: "100%" }}
              >
                <div>
                  <div className="d-flex gap-3 align-items-center justify-content-end height-72">
                    {this.state.isStateChanged && <div className="mr-auto message">
                      <span style={{ color: '#065a8c' }}>You have unsaved changes</span>
                    </div>}
                    <div className="d-flex gap-3 align-items-center">
                      {this.state.isStateChanged &&
                        this.state.formData.CustomerID > 0 && (
                          <>
                            <Button
                              variant="primary"
                              type="button"
                              className="space btn btn-primary btn-discard"
                              onClick={() =>
                                this.handleDiscard(this.state.orderUniqueNo)
                              }
                            >
                              Discard
                            </Button>
                            {/* <Button
                              id="btnSave"
                              variant="primary"
                              type="button"
                              onClick={() => this.saveOrderfinal("order", false, false)}
                              disabled={
                                this.state.formData.CustomerID === 0
                                  ? true
                                  : this.state.isDisabled
                              }
                              onKeyDown={(e: any) =>
                                this.onTAB("btnSave-1", 0, e)
                              }
                            >
                              {this.state.orderid != 0 ? "Update" : "Save"}
                            </Button> */}
                            {hasEditOrderPermission && this.state.orderid != 0 &&
                               <Button
                               id="btnSave"
                               variant="primary"
                               type="button"
                               onClick={() => this.saveOrderfinal("order", false, false)}
                               disabled={
                                 this.state.formData.CustomerID === 0
                                   ? true
                                   : this.state.isDisabled
                               }
                               onKeyDown={(e: any) =>
                                 this.onTAB("btnSave-1", 0, e)
                               }
                             >
                               {"Update"}
                             </Button>
                            }
                             {hasAddOrderPermission && this.state.orderid === 0 &&
                               <Button
                               id="btnSave"
                               variant="primary"
                               type="button"
                               onClick={() => this.saveOrderfinal("order", false, false)}
                               disabled={
                                 this.state.formData.CustomerID === 0
                                   ? true
                                   : this.state.isDisabled
                               }
                               onKeyDown={(e: any) =>
                                 this.onTAB("btnSave-1", 0, e)
                               }
                             >
                               {"Save"}
                             </Button>
                            }
                           
                          </>
                        )}
                    </div>
                  </div>
                </div>
              </div>

            </div>




            {this.state.isDuplicate && (
               <div
               //className="d-flex align-items-center pos-fxd2 index-1000"
               >
                 <div className="react-confirm-alert-overlay confirm-modal undefined">
                  <div className="react-confirm-alert">
                    <div className="react-confirm-alert-body">
                      <h1>Confirmation</h1>
                      This part is already added.
                      <div className="react-confirm-alert-button-group">
                        <button
                          type="button"
                          className="btn"
                          onClick={(e) => this.CancelRow(e)}
                        >
                          Ok
                        </button>
                        {/* <button
                          type="button"
                          className="btn"
                          onClick={(e) => this.AddedRow(e)}
                        >
                          Yes
                        </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.state.unsave && (
               <div
               //className="d-flex align-items-center pos-fxd2 index-1000"
               >
                 <div className="react-confirm-alert-overlay confirm-modal undefined">
                  <div className="react-confirm-alert">
                    <div className="react-confirm-alert-body">
                      <h1>Confirmation</h1>
                      Please save this record before creating its job.
                      <div className="react-confirm-alert-button-group">
                        <button
                          type="button"
                          className="btn"
                          onClick={(e) => this.Cancelunsave(e)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="btn"
                          //  onClick={(e) => this.saveOrderfinal("order", false,false)}
                          onClick={() => this.saveOrderfinal("orderjob", false, true)}
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}


            {showjobrModal && (

              <JobCreations
                closeSlideOut={this.closeSlideOut2}
                reopenSlideOutWithNextJob={this.reopenSlideOutWithNextJob}
                reopenSlideOutWithReworkJob={this.reopenSlideOutWithReworkJob}
                jobid={this.state.jobid}
                orderid={this.state.orderid}


                CustomerPoNumber={this.state.formData.CustomerPoNumber}
                poNumber={this.state.poNumber}
                productid={this.state.productid}
                partname={this.state.partname}
                partNo={this.state.partNo}
                qtyOrdered={this.state.qtyOrdered}

                itemNo={this.state.itemNo}
                selectedCustomer={this.state.selectedCustomer}
                orderdate={this.state.orderdate}
                dueDate={this.state.dueDate}
                jobDesc={this.state.jobDesc}
                id={this.state.id}
                rNo={this.state.rNo}
                processlist={this.state.processdataList}
              >


              </JobCreations>
            )}
            {(this.state.isSpinner || this.state.isSaveSpinner) && (
              <div className="loader-spinner d-flex justify-content-center align-items-center">
                <Spinner animation="border" variant="success" />
              </div>
            )}


              {(showShippingSlideout &&
                            <ShippingSlideout
                              closeSlideOut={this.closeShippingSlideOut}
                              orderid={this.state.orderid}
                              jobids={this.state.jobIds}
                              shipmentId={this.state.shipmentId}
                            >
            
            
                            </ShippingSlideout>
                          )} 


<Modal show={this.state.showPopup} onHide={()=>{this.setState({showPopup:false});}}>
          <Modal.Header>
            <Modal.Title>Edit Part Description</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="formDescription">
              <Form.Label>Part Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={this.state.currentNote}
                onChange={(e)=>{this.setState({ currentNote: e.target.value });}}
                placeholder="Edit the description..."
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={()=>{this.setState({showPopup:false});}}>
              Cancel
            </Button>
            {this.state.selectedjobno=="" &&
            <Button variant="primary"   onClick={this.handleNotesSave}>
              Save
            </Button>
  }
          </Modal.Footer>
        </Modal>

          </Container>
       
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId 
});


export default connect(mapStateToProps)(Customerorderslideout);